/*!
* Customized version of iScroll.js 0.0.5
* It fixes bugs affecting its integration with fullpage.js
*/
/*! iScroll v5.2.0 ~ (c) 2008-2016 Matteo Spinelli ~ http://cubiq.org/license */
(function (window, document, Math) {
  var rAF = window.requestAnimationFrame  ||
    window.webkitRequestAnimationFrame  ||
    window.mozRequestAnimationFrame     ||
    window.oRequestAnimationFrame       ||
    window.msRequestAnimationFrame      ||
    function (callback) { window.setTimeout(callback, 1000 / 60); };

  var utils = (function () {
    var me = {};

    var _elementStyle = document.createElement('div').style;
    var _vendor = (function () {
      var vendors = ['t', 'webkitT', 'MozT', 'msT', 'OT'],
        transform,
        i = 0,
        l = vendors.length;

      for ( ; i < l; i++ ) {
        transform = vendors[i] + 'ransform';
        if ( transform in _elementStyle ) return vendors[i].substr(0, vendors[i].length-1);
      }

      return false;
    })();

    function _prefixStyle (style) {
      if ( _vendor === false ) return false;
      if ( _vendor === '' ) return style;
      return _vendor + style.charAt(0).toUpperCase() + style.substr(1);
    }

    me.getTime = Date.now || function getTime () { return new Date().getTime(); };

    me.extend = function (target, obj) {
      for ( var i in obj ) {
        target[i] = obj[i];
      }
    };

    me.addEvent = function (el, type, fn, capture) {
      el.addEventListener(type, fn, !!capture);
    };

    me.removeEvent = function (el, type, fn, capture) {
      el.removeEventListener(type, fn, !!capture);
    };

    me.prefixPointerEvent = function (pointerEvent) {
      return window.MSPointerEvent ?
        'MSPointer' + pointerEvent.charAt(7).toUpperCase() + pointerEvent.substr(8):
        pointerEvent;
    };

    me.momentum = function (current, start, time, lowerMargin, wrapperSize, deceleration) {
      var distance = current - start,
        speed = Math.abs(distance) / time,
        destination,
        duration;

      deceleration = deceleration === undefined ? 0.0006 : deceleration;

      destination = current + ( speed * speed ) / ( 2 * deceleration ) * ( distance < 0 ? -1 : 1 );
      duration = speed / deceleration;

      if ( destination < lowerMargin ) {
        destination = wrapperSize ? lowerMargin - ( wrapperSize / 2.5 * ( speed / 8 ) ) : lowerMargin;
        distance = Math.abs(destination - current);
        duration = distance / speed;
      } else if ( destination > 0 ) {
        destination = wrapperSize ? wrapperSize / 2.5 * ( speed / 8 ) : 0;
        distance = Math.abs(current) + destination;
        duration = distance / speed;
      }

      return {
        destination: Math.round(destination),
        duration: duration
      };
    };

    var _transform = _prefixStyle('transform');

    me.extend(me, {
      hasTransform: _transform !== false,
      hasPerspective: _prefixStyle('perspective') in _elementStyle,
      hasTouch: 'ontouchstart' in window,
      hasPointer: !!(window.PointerEvent || window.MSPointerEvent), // IE10 is prefixed
      hasTransition: _prefixStyle('transition') in _elementStyle
    });

    /*
    This should find all Android browsers lower than build 535.19 (both stock browser and webview)
    - galaxy S2 is ok
    - 2.3.6 : `AppleWebKit/533.1 (KHTML, like Gecko) Version/4.0 Mobile Safari/533.1`
    - 4.0.4 : `AppleWebKit/534.30 (KHTML, like Gecko) Version/4.0 Mobile Safari/534.30`
   - galaxy S3 is badAndroid (stock brower, webview)
     `AppleWebKit/534.30 (KHTML, like Gecko) Version/4.0 Mobile Safari/534.30`
   - galaxy S4 is badAndroid (stock brower, webview)
     `AppleWebKit/534.30 (KHTML, like Gecko) Version/4.0 Mobile Safari/534.30`
   - galaxy S5 is OK
     `AppleWebKit/537.36 (KHTML, like Gecko) Version/4.0 Mobile Safari/537.36 (Chrome/)`
   - galaxy S6 is OK
     `AppleWebKit/537.36 (KHTML, like Gecko) Version/4.0 Mobile Safari/537.36 (Chrome/)`
  */
    me.isBadAndroid = (function() {
      var appVersion = window.navigator.appVersion;
      // Android browser is not a chrome browser.
      if (/Android/.test(appVersion) && !(/Chrome\/\d/.test(appVersion))) {
        var safariVersion = appVersion.match(/Safari\/(\d+.\d)/);
        if(safariVersion && typeof safariVersion === "object" && safariVersion.length >= 2) {
          return parseFloat(safariVersion[1]) < 535.19;
        } else {
          return true;
        }
      } else {
        return false;
      }
    })();

    me.extend(me.style = {}, {
      transform: _transform,
      transitionTimingFunction: _prefixStyle('transitionTimingFunction'),
      transitionDuration: _prefixStyle('transitionDuration'),
      transitionDelay: _prefixStyle('transitionDelay'),
      transformOrigin: _prefixStyle('transformOrigin')
    });

    me.hasClass = function (e, c) {
      var re = new RegExp("(^|\\s)" + c + "(\\s|$)");
      return re.test(e.className);
    };

    me.addClass = function (e, c) {
      if ( me.hasClass(e, c) ) {
        return;
      }

      var newclass = e.className.split(' ');
      newclass.push(c);
      e.className = newclass.join(' ');
    };

    me.removeClass = function (e, c) {
      if ( !me.hasClass(e, c) ) {
        return;
      }

      var re = new RegExp("(^|\\s)" + c + "(\\s|$)", 'g');
      e.className = e.className.replace(re, ' ');
    };

    me.offset = function (el) {
      var left = -el.offsetLeft,
        top = -el.offsetTop;

      // jshint -W084
      while (el = el.offsetParent) {
        left -= el.offsetLeft;
        top -= el.offsetTop;
      }
      // jshint +W084

      return {
        left: left,
        top: top
      };
    };

    me.preventDefaultException = function (el, exceptions) {
      for ( var i in exceptions ) {
        if ( exceptions[i].test(el[i]) ) {
          return true;
        }
      }

      return false;
    };

    me.extend(me.eventType = {}, {
      touchstart: 1,
      touchmove: 1,
      touchend: 1,

      mousedown: 2,
      mousemove: 2,
      mouseup: 2,

      pointerdown: 3,
      pointermove: 3,
      pointerup: 3,

      MSPointerDown: 3,
      MSPointerMove: 3,
      MSPointerUp: 3
    });

    me.extend(me.ease = {}, {
      quadratic: {
        style: 'cubic-bezier(0.25, 0.46, 0.45, 0.94)',
        fn: function (k) {
          return k * ( 2 - k );
        }
      },
      circular: {
        style: 'cubic-bezier(0.1, 0.57, 0.1, 1)',   // Not properly "circular" but this looks better, it should be (0.075, 0.82, 0.165, 1)
        fn: function (k) {
          return Math.sqrt( 1 - ( --k * k ) );
        }
      },
      back: {
        style: 'cubic-bezier(0.175, 0.885, 0.32, 1.275)',
        fn: function (k) {
          var b = 4;
          return ( k = k - 1 ) * k * ( ( b + 1 ) * k + b ) + 1;
        }
      },
      bounce: {
        style: '',
        fn: function (k) {
          if ( ( k /= 1 ) < ( 1 / 2.75 ) ) {
            return 7.5625 * k * k;
          } else if ( k < ( 2 / 2.75 ) ) {
            return 7.5625 * ( k -= ( 1.5 / 2.75 ) ) * k + 0.75;
          } else if ( k < ( 2.5 / 2.75 ) ) {
            return 7.5625 * ( k -= ( 2.25 / 2.75 ) ) * k + 0.9375;
          } else {
            return 7.5625 * ( k -= ( 2.625 / 2.75 ) ) * k + 0.984375;
          }
        }
      },
      elastic: {
        style: '',
        fn: function (k) {
          var f = 0.22,
            e = 0.4;

          if ( k === 0 ) { return 0; }
          if ( k == 1 ) { return 1; }

          return ( e * Math.pow( 2, - 10 * k ) * Math.sin( ( k - f / 4 ) * ( 2 * Math.PI ) / f ) + 1 );
        }
      }
    });

    me.tap = function (e, eventName) {
      var ev = document.createEvent('Event');
      ev.initEvent(eventName, true, true);
      ev.pageX = e.pageX;
      ev.pageY = e.pageY;
      e.target.dispatchEvent(ev);
    };

    me.click = function (e) {
      var target = e.target,
        ev;

      if ( !(/(SELECT|INPUT|TEXTAREA)/i).test(target.tagName) ) {
        // https://developer.mozilla.org/en-US/docs/Web/API/MouseEvent/initMouseEvent
        // initMouseEvent is deprecated.
        ev = new MouseEvent('click', {
          view: e.view || window,
          detail: 1,
          screenX: target.screenX || 0,
          screenY: target.screenY || 0,
          clientX: target.clientX || 0,
          clientY: target.clientY || 0,
          ctrlKey: !!e.ctrlKey,
          altKey: !!e.altKey,
          shiftKey: !!e.shiftKey,
          metaKey: !!e.metaKey,
          button: 0,
          relatedTarget: null,
          _constructed: true
        });

        target.dispatchEvent(ev);
      }
    };

    return me;
  })();
  window.IScroll = function (el, options) {
    this.wrapper = typeof el == 'string' ? document.querySelector(el) : el;
    this.scroller = this.wrapper.children[0];
    this.scrollerStyle = this.scroller.style;       // cache style for better performance

    this.options = {

      resizeScrollbars: true,

      mouseWheelSpeed: 20,

      snapThreshold: 0.334,

      // INSERT POINT: OPTIONS
      disablePointer : !utils.hasPointer,
      disableTouch : utils.hasPointer || !utils.hasTouch,
      disableMouse : utils.hasPointer || utils.hasTouch,
      startX: 0,
      startY: 0,
      scrollY: true,
      directionLockThreshold: 5,
      momentum: true,

      bounce: true,
      bounceTime: 600,
      bounceEasing: '',

      preventDefault: true,
      preventDefaultException: { tagName: /^(INPUT|TEXTAREA|BUTTON|SELECT|LABEL|A)$/ },

      HWCompositing: true,
      useTransition: true,
      useTransform: true,
      bindToWrapper: typeof window.onmousedown === "undefined"
    };

    for ( var i in options ) {
      this.options[i] = options[i];
    }

    // Normalize options
    this.translateZ = this.options.HWCompositing && utils.hasPerspective ? ' translateZ(0)' : '';

    this.options.useTransition = utils.hasTransition && this.options.useTransition;
    this.options.useTransform = utils.hasTransform && this.options.useTransform;

    this.options.eventPassthrough = this.options.eventPassthrough === true ? 'vertical' : this.options.eventPassthrough;
    this.options.preventDefault = !this.options.eventPassthrough && this.options.preventDefault;

    // If you want eventPassthrough I have to lock one of the axes
    this.options.scrollY = this.options.eventPassthrough == 'vertical' ? false : this.options.scrollY;
    this.options.scrollX = this.options.eventPassthrough == 'horizontal' ? false : this.options.scrollX;

    // With eventPassthrough we also need lockDirection mechanism
    this.options.freeScroll = this.options.freeScroll && !this.options.eventPassthrough;
    this.options.directionLockThreshold = this.options.eventPassthrough ? 0 : this.options.directionLockThreshold;

    this.options.bounceEasing = typeof this.options.bounceEasing == 'string' ? utils.ease[this.options.bounceEasing] || utils.ease.circular : this.options.bounceEasing;

    this.options.resizePolling = this.options.resizePolling === undefined ? 60 : this.options.resizePolling;

    if ( this.options.tap === true ) {
      this.options.tap = 'tap';
    }

    // https://github.com/cubiq/iscroll/issues/1029
    if (!this.options.useTransition && !this.options.useTransform) {
      if(!(/relative|absolute/i).test(this.scrollerStyle.position)) {
        this.scrollerStyle.position = "relative";
      }
    }

    if ( this.options.shrinkScrollbars == 'scale' ) {
      this.options.useTransition = false;
    }

    this.options.invertWheelDirection = this.options.invertWheelDirection ? -1 : 1;

    // INSERT POINT: NORMALIZATION

    // Some defaults
    this.x = 0;
    this.y = 0;
    this.directionX = 0;
    this.directionY = 0;
    this._events = {};

    // INSERT POINT: DEFAULTS

    this._init();
    this.refresh();

    this.scrollTo(this.options.startX, this.options.startY);
    this.enable();
  }

  IScroll.prototype = {
    version: '5.2.0',

    _init: function () {
      this._initEvents();

      if ( this.options.scrollbars || this.options.indicators ) {
        this._initIndicators();
      }

      if ( this.options.mouseWheel ) {
        this._initWheel();
      }

      if ( this.options.snap ) {
        this._initSnap();
      }

      if ( this.options.keyBindings ) {
        this._initKeys();
      }

      // INSERT POINT: _init

    },

    destroy: function () {
      this._initEvents(true);
      clearTimeout(this.resizeTimeout);
      this.resizeTimeout = null;
      this._execEvent('destroy');
    },

    _transitionEnd: function (e) {
      if ( e.target != this.scroller || !this.isInTransition ) {
        return;
      }

      this._transitionTime();
      if ( !this.resetPosition(this.options.bounceTime) ) {
        this.isInTransition = false;
        this._execEvent('scrollEnd');
      }
    },

    _start: function (e) {
      // React to left mouse button only
      if ( utils.eventType[e.type] != 1 ) {
        // for button property
        // http://unixpapa.com/js/mouse.html
        var button;
        if (!e.which) {
          /* IE case */
          button = (e.button < 2) ? 0 :
            ((e.button == 4) ? 1 : 2);
        } else {
          /* All others */
          button = e.button;
        }
        if ( button !== 0 ) {
          return;
        }
      }

      if ( !this.enabled || (this.initiated && utils.eventType[e.type] !== this.initiated) ) {
        return;
      }

      if ( this.options.preventDefault && !utils.isBadAndroid && !utils.preventDefaultException(e.target, this.options.preventDefaultException) ) {
        e.preventDefault();
      }

      var point = e.touches ? e.touches[0] : e,
        pos;

      this.initiated  = utils.eventType[e.type];
      this.moved      = false;
      this.distX      = 0;
      this.distY      = 0;
      this.directionX = 0;
      this.directionY = 0;
      this.directionLocked = 0;

      this.startTime = utils.getTime();

      if ( this.options.useTransition && this.isInTransition ) {
        this._transitionTime();
        this.isInTransition = false;
        pos = this.getComputedPosition();
        this._translate(Math.round(pos.x), Math.round(pos.y));
        this._execEvent('scrollEnd');
      } else if ( !this.options.useTransition && this.isAnimating ) {
        this.isAnimating = false;
        this._execEvent('scrollEnd');
      }

      this.startX    = this.x;
      this.startY    = this.y;
      this.absStartX = this.x;
      this.absStartY = this.y;
      this.pointX    = point.pageX;
      this.pointY    = point.pageY;

      this._execEvent('beforeScrollStart');
    },

    _move: function (e) {
      if ( !this.enabled || utils.eventType[e.type] !== this.initiated ) {
        return;
      }

      if ( this.options.preventDefault ) {    // increases performance on Android? TODO: check!
        e.preventDefault();
      }

      var point       = e.touches ? e.touches[0] : e,
        deltaX      = point.pageX - this.pointX,
        deltaY      = point.pageY - this.pointY,
        timestamp   = utils.getTime(),
        newX, newY,
        absDistX, absDistY;

      this.pointX     = point.pageX;
      this.pointY     = point.pageY;

      this.distX      += deltaX;
      this.distY      += deltaY;
      absDistX        = Math.abs(this.distX);
      absDistY        = Math.abs(this.distY);

      // We need to move at least 10 pixels for the scrolling to initiate
      if ( timestamp - this.endTime > 300 && (absDistX < 10 && absDistY < 10) ) {
        return;
      }

      // If you are scrolling in one direction lock the other
      if ( !this.directionLocked && !this.options.freeScroll ) {
        if ( absDistX > absDistY + this.options.directionLockThreshold ) {
          this.directionLocked = 'h';     // lock horizontally
        } else if ( absDistY >= absDistX + this.options.directionLockThreshold ) {
          this.directionLocked = 'v';     // lock vertically
        } else {
          this.directionLocked = 'n';     // no lock
        }
      }

      if ( this.directionLocked == 'h' ) {
        if ( this.options.eventPassthrough == 'vertical' ) {
          e.preventDefault();
        } else if ( this.options.eventPassthrough == 'horizontal' ) {
          this.initiated = false;
          return;
        }

        deltaY = 0;
      } else if ( this.directionLocked == 'v' ) {
        if ( this.options.eventPassthrough == 'horizontal' ) {
          e.preventDefault();
        } else if ( this.options.eventPassthrough == 'vertical' ) {
          this.initiated = false;
          return;
        }

        deltaX = 0;
      }

      deltaX = this.hasHorizontalScroll ? deltaX : 0;
      deltaY = this.hasVerticalScroll ? deltaY : 0;

      newX = this.x + deltaX;
      newY = this.y + deltaY;

      // Slow down if outside of the boundaries
      if ( newX > 0 || newX < this.maxScrollX ) {
        newX = this.options.bounce ? this.x + deltaX / 3 : newX > 0 ? 0 : this.maxScrollX;
      }
      if ( newY > 0 || newY < this.maxScrollY ) {
        newY = this.options.bounce ? this.y + deltaY / 3 : newY > 0 ? 0 : this.maxScrollY;
      }

      this.directionX = deltaX > 0 ? -1 : deltaX < 0 ? 1 : 0;
      this.directionY = deltaY > 0 ? -1 : deltaY < 0 ? 1 : 0;

      if ( !this.moved ) {
        this._execEvent('scrollStart');
      }

      this.moved = true;

      this._translate(newX, newY);

      /* REPLACE START: _move */

      if ( timestamp - this.startTime > 300 ) {
        this.startTime = timestamp;
        this.startX = this.x;
        this.startY = this.y;
      }

      /* REPLACE END: _move */

    },

    _end: function (e) {
      if ( !this.enabled || utils.eventType[e.type] !== this.initiated ) {
        return;
      }

      if ( this.options.preventDefault && !utils.preventDefaultException(e.target, this.options.preventDefaultException) ) {
        e.preventDefault();
      }

      var point = e.changedTouches ? e.changedTouches[0] : e,
        momentumX,
        momentumY,
        duration = utils.getTime() - this.startTime,
        newX = Math.round(this.x),
        newY = Math.round(this.y),
        distanceX = Math.abs(newX - this.startX),
        distanceY = Math.abs(newY - this.startY),
        time = 0,
        easing = '';

      this.isInTransition = 0;
      this.initiated = 0;
      this.endTime = utils.getTime();

      // reset if we are outside of the boundaries
      if ( this.resetPosition(this.options.bounceTime) ) {
        return;
      }

      this.scrollTo(newX, newY);  // ensures that the last position is rounded

      // we scrolled less than 10 pixels
      if ( !this.moved ) {
        if ( this.options.tap ) {
          utils.tap(e, this.options.tap);
        }

        if ( this.options.click ) {
          utils.click(e);
        }

        this._execEvent('scrollCancel');
        return;
      }

      if ( this._events.flick && duration < 200 && distanceX < 100 && distanceY < 100 ) {
        this._execEvent('flick');
        return;
      }

      // start momentum animation if needed
      if ( this.options.momentum && duration < 300 ) {
        momentumX = this.hasHorizontalScroll ? utils.momentum(this.x, this.startX, duration, this.maxScrollX, this.options.bounce ? this.wrapperWidth : 0, this.options.deceleration) : { destination: newX, duration: 0 };
        momentumY = this.hasVerticalScroll ? utils.momentum(this.y, this.startY, duration, this.maxScrollY, this.options.bounce ? this.wrapperHeight : 0, this.options.deceleration) : { destination: newY, duration: 0 };
        newX = momentumX.destination;
        newY = momentumY.destination;
        time = Math.max(momentumX.duration, momentumY.duration);
        this.isInTransition = 1;
      }


      if ( this.options.snap ) {
        var snap = this._nearestSnap(newX, newY);
        this.currentPage = snap;
        time = this.options.snapSpeed || Math.max(
          Math.max(
            Math.min(Math.abs(newX - snap.x), 1000),
            Math.min(Math.abs(newY - snap.y), 1000)
          ), 300);
        newX = snap.x;
        newY = snap.y;

        this.directionX = 0;
        this.directionY = 0;
        easing = this.options.bounceEasing;
      }

      // INSERT POINT: _end

      if ( newX != this.x || newY != this.y ) {
        // change easing function when scroller goes out of the boundaries
        if ( newX > 0 || newX < this.maxScrollX || newY > 0 || newY < this.maxScrollY ) {
          easing = utils.ease.quadratic;
        }

        this.scrollTo(newX, newY, time, easing);
        return;
      }

      this._execEvent('scrollEnd');
    },

    _resize: function () {
      var that = this;

      clearTimeout(this.resizeTimeout);

      this.resizeTimeout = setTimeout(function () {
        that.refresh();
      }, this.options.resizePolling);
    },

    resetPosition: function (time) {
      var x = this.x,
        y = this.y;

      time = time || 0;

      if ( !this.hasHorizontalScroll || this.x > 0 ) {
        x = 0;
      } else if ( this.x < this.maxScrollX ) {
        x = this.maxScrollX;
      }

      if ( !this.hasVerticalScroll || this.y > 0 ) {
        y = 0;
      } else if ( this.y < this.maxScrollY ) {
        y = this.maxScrollY;
      }

      if ( x == this.x && y == this.y ) {
        return false;
      }

      this.scrollTo(x, y, time, this.options.bounceEasing);

      return true;
    },

    disable: function () {
      this.enabled = false;
    },

    enable: function () {
      this.enabled = true;
    },

    refresh: function () {
      var rf = this.wrapper.offsetHeight;     // Force reflow

      this.wrapperWidth   = this.wrapper.clientWidth;
      this.wrapperHeight  = this.wrapper.clientHeight;

      /* REPLACE START: refresh */

      this.scrollerWidth  = this.scroller.offsetWidth;
      this.scrollerHeight = this.scroller.offsetHeight;

      this.maxScrollX     = this.wrapperWidth - this.scrollerWidth;
      this.maxScrollY     = this.wrapperHeight - this.scrollerHeight;

      /* REPLACE END: refresh */

      this.hasHorizontalScroll    = this.options.scrollX && this.maxScrollX < 0;
      this.hasVerticalScroll      = this.options.scrollY && this.maxScrollY < 0;

      if ( !this.hasHorizontalScroll ) {
        this.maxScrollX = 0;
        this.scrollerWidth = this.wrapperWidth;
      }

      if ( !this.hasVerticalScroll ) {
        this.maxScrollY = 0;
        this.scrollerHeight = this.wrapperHeight;
      }

      this.endTime = 0;
      this.directionX = 0;
      this.directionY = 0;

      this.wrapperOffset = utils.offset(this.wrapper);

      this._execEvent('refresh');

      this.resetPosition();

      // INSERT POINT: _refresh

    },

    on: function (type, fn) {
      if ( !this._events[type] ) {
        this._events[type] = [];
      }

      this._events[type].push(fn);
    },

    off: function (type, fn) {
      if ( !this._events[type] ) {
        return;
      }

      var index = this._events[type].indexOf(fn);

      if ( index > -1 ) {
        this._events[type].splice(index, 1);
      }
    },

    _execEvent: function (type) {
      if ( !this._events[type] ) {
        return;
      }

      var i = 0,
        l = this._events[type].length;

      if ( !l ) {
        return;
      }

      for ( ; i < l; i++ ) {
        this._events[type][i].apply(this, [].slice.call(arguments, 1));
      }
    },

    scrollBy: function (x, y, time, easing) {
      x = this.x + x;
      y = this.y + y;
      time = time || 0;

      this.scrollTo(x, y, time, easing);
    },

    scrollTo: function (x, y, time, easing) {
      easing = easing || utils.ease.circular;

      this.isInTransition = this.options.useTransition && time > 0;
      var transitionType = this.options.useTransition && easing.style;
      if ( !time || transitionType ) {
        if(transitionType) {
          this._transitionTimingFunction(easing.style);
          this._transitionTime(time);
        }
        this._translate(x, y);
      } else {
        this._animate(x, y, time, easing.fn);
      }
    },

    scrollToElement: function (el, time, offsetX, offsetY, easing) {
      el = el.nodeType ? el : this.scroller.querySelector(el);

      if ( !el ) {
        return;
      }

      var pos = utils.offset(el);

      pos.left -= this.wrapperOffset.left;
      pos.top  -= this.wrapperOffset.top;

      // if offsetX/Y are true we center the element to the screen
      if ( offsetX === true ) {
        offsetX = Math.round(el.offsetWidth / 2 - this.wrapper.offsetWidth / 2);
      }
      if ( offsetY === true ) {
        offsetY = Math.round(el.offsetHeight / 2 - this.wrapper.offsetHeight / 2);
      }

      pos.left -= offsetX || 0;
      pos.top  -= offsetY || 0;

      pos.left = pos.left > 0 ? 0 : pos.left < this.maxScrollX ? this.maxScrollX : pos.left;
      pos.top  = pos.top  > 0 ? 0 : pos.top  < this.maxScrollY ? this.maxScrollY : pos.top;

      time = time === undefined || time === null || time === 'auto' ? Math.max(Math.abs(this.x-pos.left), Math.abs(this.y-pos.top)) : time;

      this.scrollTo(pos.left, pos.top, time, easing);
    },

    _transitionTime: function (time) {
      if (!this.options.useTransition) {
        return;
      }
      time = time || 0;
      var durationProp = utils.style.transitionDuration;
      if(!durationProp) {
        return;
      }

      this.scrollerStyle[durationProp] = time + 'ms';

      if ( !time && utils.isBadAndroid ) {
        this.scrollerStyle[durationProp] = '0.0001ms';
        // remove 0.0001ms
        var self = this;
        rAF(function() {
          if(self.scrollerStyle[durationProp] === '0.0001ms') {
            self.scrollerStyle[durationProp] = '0s';
          }
        });
      }


      if ( this.indicators ) {
        for ( var i = this.indicators.length; i--; ) {
          this.indicators[i].transitionTime(time);
        }
      }


      // INSERT POINT: _transitionTime

    },

    _transitionTimingFunction: function (easing) {
      this.scrollerStyle[utils.style.transitionTimingFunction] = easing;


      if ( this.indicators ) {
        for ( var i = this.indicators.length; i--; ) {
          this.indicators[i].transitionTimingFunction(easing);
        }
      }


      // INSERT POINT: _transitionTimingFunction

    },

    _translate: function (x, y) {
      if ( this.options.useTransform ) {

        /* REPLACE START: _translate */

        this.scrollerStyle[utils.style.transform] = 'translate(' + x + 'px,' + y + 'px)' + this.translateZ;

        /* REPLACE END: _translate */

      } else {
        x = Math.round(x);
        y = Math.round(y);
        this.scrollerStyle.left = x + 'px';
        this.scrollerStyle.top = y + 'px';
      }

      this.x = x;
      this.y = y;


      if ( this.indicators ) {
        for ( var i = this.indicators.length; i--; ) {
          this.indicators[i].updatePosition();
        }
      }


      // INSERT POINT: _translate

    },

    _initEvents: function (remove) {
      var eventType = remove ? utils.removeEvent : utils.addEvent,
        target = this.options.bindToWrapper ? this.wrapper : window;

      eventType(window, 'orientationchange', this);
      eventType(window, 'resize', this);

      if ( this.options.click ) {
        eventType(this.wrapper, 'click', this, true);
      }

      if ( !this.options.disableMouse ) {
        eventType(this.wrapper, 'mousedown', this);
        eventType(target, 'mousemove', this);
        eventType(target, 'mousecancel', this);
        eventType(target, 'mouseup', this);
      }

      if ( utils.hasPointer && !this.options.disablePointer ) {
        eventType(this.wrapper, utils.prefixPointerEvent('pointerdown'), this);
        eventType(target, utils.prefixPointerEvent('pointermove'), this);
        eventType(target, utils.prefixPointerEvent('pointercancel'), this);
        eventType(target, utils.prefixPointerEvent('pointerup'), this);
      }

      if ( utils.hasTouch && !this.options.disableTouch ) {
        eventType(this.wrapper, 'touchstart', this);
        eventType(target, 'touchmove', this);
        eventType(target, 'touchcancel', this);
        eventType(target, 'touchend', this);
      }

      eventType(this.scroller, 'transitionend', this);
      eventType(this.scroller, 'webkitTransitionEnd', this);
      eventType(this.scroller, 'oTransitionEnd', this);
      eventType(this.scroller, 'MSTransitionEnd', this);
    },

    getComputedPosition: function () {
      var matrix = window.getComputedStyle(this.scroller, null),
        x, y;

      if ( this.options.useTransform ) {
        matrix = matrix[utils.style.transform].split(')')[0].split(', ');
        x = +(matrix[12] || matrix[4]);
        y = +(matrix[13] || matrix[5]);
      } else {
        x = +matrix.left.replace(/[^-\d.]/g, '');
        y = +matrix.top.replace(/[^-\d.]/g, '');
      }

      return { x: x, y: y };
    },
    _initIndicators: function () {
      var interactive = this.options.interactiveScrollbars,
        customStyle = typeof this.options.scrollbars != 'string',
        indicators = [],
        indicator;

      var that = this;

      this.indicators = [];

      if ( this.options.scrollbars ) {
        // Vertical scrollbar
        if ( this.options.scrollY ) {
          indicator = {
            el: createDefaultScrollbar('v', interactive, this.options.scrollbars),
            interactive: interactive,
            defaultScrollbars: true,
            customStyle: customStyle,
            resize: this.options.resizeScrollbars,
            shrink: this.options.shrinkScrollbars,
            fade: this.options.fadeScrollbars,
            listenX: false
          };

          this.wrapper.appendChild(indicator.el);
          indicators.push(indicator);
        }

        // Horizontal scrollbar
        if ( this.options.scrollX ) {
          indicator = {
            el: createDefaultScrollbar('h', interactive, this.options.scrollbars),
            interactive: interactive,
            defaultScrollbars: true,
            customStyle: customStyle,
            resize: this.options.resizeScrollbars,
            shrink: this.options.shrinkScrollbars,
            fade: this.options.fadeScrollbars,
            listenY: false
          };

          this.wrapper.appendChild(indicator.el);
          indicators.push(indicator);
        }
      }

      if ( this.options.indicators ) {
        // TODO: check concat compatibility
        indicators = indicators.concat(this.options.indicators);
      }

      for ( var i = indicators.length; i--; ) {
        this.indicators.push( new Indicator(this, indicators[i]) );
      }

      // TODO: check if we can use array.map (wide compatibility and performance issues)
      function _indicatorsMap (fn) {
        if (that.indicators) {
          for ( var i = that.indicators.length; i--; ) {
            fn.call(that.indicators[i]);
          }
        }
      }

      if ( this.options.fadeScrollbars ) {
        this.on('scrollEnd', function () {
          _indicatorsMap(function () {
            this.fade();
          });
        });

        this.on('scrollCancel', function () {
          _indicatorsMap(function () {
            this.fade();
          });
        });

        this.on('scrollStart', function () {
          _indicatorsMap(function () {
            this.fade(1);
          });
        });

        this.on('beforeScrollStart', function () {
          _indicatorsMap(function () {
            this.fade(1, true);
          });
        });
      }


      this.on('refresh', function () {
        _indicatorsMap(function () {
          this.refresh();
        });
      });

      this.on('destroy', function () {
        _indicatorsMap(function () {
          this.destroy();
        });

        delete this.indicators;
      });
    },

    _initWheel: function () {
      utils.addEvent(this.wrapper, 'wheel', this);
      utils.addEvent(this.wrapper, 'mousewheel', this);
      utils.addEvent(this.wrapper, 'DOMMouseScroll', this);

      this.on('destroy', function () {
        clearTimeout(this.wheelTimeout);
        this.wheelTimeout = null;
        utils.removeEvent(this.wrapper, 'wheel', this);
        utils.removeEvent(this.wrapper, 'mousewheel', this);
        utils.removeEvent(this.wrapper, 'DOMMouseScroll', this);
      });
    },

    _wheel: function (e) {
      if ( !this.enabled ) {
        return;
      }

      var wheelDeltaX, wheelDeltaY,
        newX, newY,
        that = this;

      if ( this.wheelTimeout === undefined ) {
        that._execEvent('scrollStart');
      }

      // Execute the scrollEnd event after 400ms the wheel stopped scrolling
      clearTimeout(this.wheelTimeout);
      this.wheelTimeout = setTimeout(function () {
        if(!that.options.snap) {
          that._execEvent('scrollEnd');
        }
        that.wheelTimeout = undefined;
      }, 400);

      if ( 'deltaX' in e ) {
        if (e.deltaMode === 1) {
          wheelDeltaX = -e.deltaX * this.options.mouseWheelSpeed;
          wheelDeltaY = -e.deltaY * this.options.mouseWheelSpeed;
        } else {
          wheelDeltaX = -e.deltaX;
          wheelDeltaY = -e.deltaY;
        }
      } else if ( 'wheelDeltaX' in e ) {
        wheelDeltaX = e.wheelDeltaX / 120 * this.options.mouseWheelSpeed;
        wheelDeltaY = e.wheelDeltaY / 120 * this.options.mouseWheelSpeed;
      } else if ( 'wheelDelta' in e ) {
        wheelDeltaX = wheelDeltaY = e.wheelDelta / 120 * this.options.mouseWheelSpeed;
      } else if ( 'detail' in e ) {
        wheelDeltaX = wheelDeltaY = -e.detail / 3 * this.options.mouseWheelSpeed;
      } else {
        return;
      }

      wheelDeltaX *= this.options.invertWheelDirection;
      wheelDeltaY *= this.options.invertWheelDirection;

      if ( !this.hasVerticalScroll ) {
        wheelDeltaX = wheelDeltaY;
        wheelDeltaY = 0;
      }

      if ( this.options.snap ) {
        newX = this.currentPage.pageX;
        newY = this.currentPage.pageY;

        if ( wheelDeltaX > 0 ) {
          newX--;
        } else if ( wheelDeltaX < 0 ) {
          newX++;
        }

        if ( wheelDeltaY > 0 ) {
          newY--;
        } else if ( wheelDeltaY < 0 ) {
          newY++;
        }

        this.goToPage(newX, newY);

        return;
      }

      newX = this.x + Math.round(this.hasHorizontalScroll ? wheelDeltaX : 0);
      newY = this.y + Math.round(this.hasVerticalScroll ? wheelDeltaY : 0);

      this.directionX = wheelDeltaX > 0 ? -1 : wheelDeltaX < 0 ? 1 : 0;
      this.directionY = wheelDeltaY > 0 ? -1 : wheelDeltaY < 0 ? 1 : 0;

      if ( newX > 0 ) {
        newX = 0;
      } else if ( newX < this.maxScrollX ) {
        newX = this.maxScrollX;
      }

      if ( newY > 0 ) {
        newY = 0;
      } else if ( newY < this.maxScrollY ) {
        newY = this.maxScrollY;
      }

      this.scrollTo(newX, newY, 0);

      // INSERT POINT: _wheel
    },

    _initSnap: function () {
      this.currentPage = {};

      if ( typeof this.options.snap == 'string' ) {
        this.options.snap = this.scroller.querySelectorAll(this.options.snap);
      }

      this.on('refresh', function () {
        var i = 0, l,
          m = 0, n,
          cx, cy,
          x = 0, y,
          stepX = this.options.snapStepX || this.wrapperWidth,
          stepY = this.options.snapStepY || this.wrapperHeight,
          el;

        this.pages = [];

        if ( !this.wrapperWidth || !this.wrapperHeight || !this.scrollerWidth || !this.scrollerHeight ) {
          return;
        }

        if ( this.options.snap === true ) {
          cx = Math.round( stepX / 2 );
          cy = Math.round( stepY / 2 );

          while ( x > -this.scrollerWidth ) {
            this.pages[i] = [];
            l = 0;
            y = 0;

            while ( y > -this.scrollerHeight ) {
              this.pages[i][l] = {
                x: Math.max(x, this.maxScrollX),
                y: Math.max(y, this.maxScrollY),
                width: stepX,
                height: stepY,
                cx: x - cx,
                cy: y - cy
              };

              y -= stepY;
              l++;
            }

            x -= stepX;
            i++;
          }
        } else {
          el = this.options.snap;
          l = el.length;
          n = -1;

          for ( ; i < l; i++ ) {
            if ( i === 0 || el[i].offsetLeft <= el[i-1].offsetLeft ) {
              m = 0;
              n++;
            }

            if ( !this.pages[m] ) {
              this.pages[m] = [];
            }

            x = Math.max(-el[i].offsetLeft, this.maxScrollX);
            y = Math.max(-el[i].offsetTop, this.maxScrollY);
            cx = x - Math.round(el[i].offsetWidth / 2);
            cy = y - Math.round(el[i].offsetHeight / 2);

            this.pages[m][n] = {
              x: x,
              y: y,
              width: el[i].offsetWidth,
              height: el[i].offsetHeight,
              cx: cx,
              cy: cy
            };

            if ( x > this.maxScrollX ) {
              m++;
            }
          }
        }

        this.goToPage(this.currentPage.pageX || 0, this.currentPage.pageY || 0, 0);

        // Update snap threshold if needed
        if ( this.options.snapThreshold % 1 === 0 ) {
          this.snapThresholdX = this.options.snapThreshold;
          this.snapThresholdY = this.options.snapThreshold;
        } else {
          this.snapThresholdX = Math.round(this.pages[this.currentPage.pageX][this.currentPage.pageY].width * this.options.snapThreshold);
          this.snapThresholdY = Math.round(this.pages[this.currentPage.pageX][this.currentPage.pageY].height * this.options.snapThreshold);
        }
      });

      this.on('flick', function () {
        var time = this.options.snapSpeed || Math.max(
          Math.max(
            Math.min(Math.abs(this.x - this.startX), 1000),
            Math.min(Math.abs(this.y - this.startY), 1000)
          ), 300);

        this.goToPage(
          this.currentPage.pageX + this.directionX,
          this.currentPage.pageY + this.directionY,
          time
        );
      });
    },

    _nearestSnap: function (x, y) {
      if ( !this.pages.length ) {
        return { x: 0, y: 0, pageX: 0, pageY: 0 };
      }

      var i = 0,
        l = this.pages.length,
        m = 0;

      // Check if we exceeded the snap threshold
      if ( Math.abs(x - this.absStartX) < this.snapThresholdX &&
        Math.abs(y - this.absStartY) < this.snapThresholdY ) {
        return this.currentPage;
      }

      if ( x > 0 ) {
        x = 0;
      } else if ( x < this.maxScrollX ) {
        x = this.maxScrollX;
      }

      if ( y > 0 ) {
        y = 0;
      } else if ( y < this.maxScrollY ) {
        y = this.maxScrollY;
      }

      for ( ; i < l; i++ ) {
        if ( x >= this.pages[i][0].cx ) {
          x = this.pages[i][0].x;
          break;
        }
      }

      l = this.pages[i].length;

      for ( ; m < l; m++ ) {
        if ( y >= this.pages[0][m].cy ) {
          y = this.pages[0][m].y;
          break;
        }
      }

      if ( i == this.currentPage.pageX ) {
        i += this.directionX;

        if ( i < 0 ) {
          i = 0;
        } else if ( i >= this.pages.length ) {
          i = this.pages.length - 1;
        }

        x = this.pages[i][0].x;
      }

      if ( m == this.currentPage.pageY ) {
        m += this.directionY;

        if ( m < 0 ) {
          m = 0;
        } else if ( m >= this.pages[0].length ) {
          m = this.pages[0].length - 1;
        }

        y = this.pages[0][m].y;
      }

      return {
        x: x,
        y: y,
        pageX: i,
        pageY: m
      };
    },

    goToPage: function (x, y, time, easing) {
      easing = easing || this.options.bounceEasing;

      if ( x >= this.pages.length ) {
        x = this.pages.length - 1;
      } else if ( x < 0 ) {
        x = 0;
      }

      if ( y >= this.pages[x].length ) {
        y = this.pages[x].length - 1;
      } else if ( y < 0 ) {
        y = 0;
      }

      var posX = this.pages[x][y].x,
        posY = this.pages[x][y].y;

      time = time === undefined ? this.options.snapSpeed || Math.max(
        Math.max(
          Math.min(Math.abs(posX - this.x), 1000),
          Math.min(Math.abs(posY - this.y), 1000)
        ), 300) : time;

      this.currentPage = {
        x: posX,
        y: posY,
        pageX: x,
        pageY: y
      };

      this.scrollTo(posX, posY, time, easing);
    },

    next: function (time, easing) {
      var x = this.currentPage.pageX,
        y = this.currentPage.pageY;

      x++;

      if ( x >= this.pages.length && this.hasVerticalScroll ) {
        x = 0;
        y++;
      }

      this.goToPage(x, y, time, easing);
    },

    prev: function (time, easing) {
      var x = this.currentPage.pageX,
        y = this.currentPage.pageY;

      x--;

      if ( x < 0 && this.hasVerticalScroll ) {
        x = 0;
        y--;
      }

      this.goToPage(x, y, time, easing);
    },

    _initKeys: function (e) {
      // default key bindings
      var keys = {
        pageUp: 33,
        pageDown: 34,
        end: 35,
        home: 36,
        left: 37,
        up: 38,
        right: 39,
        down: 40
      };
      var i;

      // if you give me characters I give you keycode
      if ( typeof this.options.keyBindings == 'object' ) {
        for ( i in this.options.keyBindings ) {
          if ( typeof this.options.keyBindings[i] == 'string' ) {
            this.options.keyBindings[i] = this.options.keyBindings[i].toUpperCase().charCodeAt(0);
          }
        }
      } else {
        this.options.keyBindings = {};
      }

      for ( i in keys ) {
        this.options.keyBindings[i] = this.options.keyBindings[i] || keys[i];
      }

      utils.addEvent(window, 'keydown', this);

      this.on('destroy', function () {
        utils.removeEvent(window, 'keydown', this);
      });
    },

    _key: function (e) {
      if ( !this.enabled ) {
        return;
      }

      var snap = this.options.snap,   // we are using this alot, better to cache it
        newX = snap ? this.currentPage.pageX : this.x,
        newY = snap ? this.currentPage.pageY : this.y,
        now = utils.getTime(),
        prevTime = this.keyTime || 0,
        acceleration = 0.250,
        pos;

      if ( this.options.useTransition && this.isInTransition ) {
        pos = this.getComputedPosition();

        this._translate(Math.round(pos.x), Math.round(pos.y));
        this.isInTransition = false;
      }

      this.keyAcceleration = now - prevTime < 200 ? Math.min(this.keyAcceleration + acceleration, 50) : 0;

      switch ( e.keyCode ) {
        case this.options.keyBindings.pageUp:
          if ( this.hasHorizontalScroll && !this.hasVerticalScroll ) {
            newX += snap ? 1 : this.wrapperWidth;
          } else {
            newY += snap ? 1 : this.wrapperHeight;
          }
          break;
        case this.options.keyBindings.pageDown:
          if ( this.hasHorizontalScroll && !this.hasVerticalScroll ) {
            newX -= snap ? 1 : this.wrapperWidth;
          } else {
            newY -= snap ? 1 : this.wrapperHeight;
          }
          break;
        case this.options.keyBindings.end:
          newX = snap ? this.pages.length-1 : this.maxScrollX;
          newY = snap ? this.pages[0].length-1 : this.maxScrollY;
          break;
        case this.options.keyBindings.home:
          newX = 0;
          newY = 0;
          break;
        case this.options.keyBindings.left:
          newX += snap ? -1 : 5 + this.keyAcceleration>>0;
          break;
        case this.options.keyBindings.up:
          newY += snap ? 1 : 5 + this.keyAcceleration>>0;
          break;
        case this.options.keyBindings.right:
          newX -= snap ? -1 : 5 + this.keyAcceleration>>0;
          break;
        case this.options.keyBindings.down:
          newY -= snap ? 1 : 5 + this.keyAcceleration>>0;
          break;
        default:
          return;
      }

      if ( snap ) {
        this.goToPage(newX, newY);
        return;
      }

      if ( newX > 0 ) {
        newX = 0;
        this.keyAcceleration = 0;
      } else if ( newX < this.maxScrollX ) {
        newX = this.maxScrollX;
        this.keyAcceleration = 0;
      }

      if ( newY > 0 ) {
        newY = 0;
        this.keyAcceleration = 0;
      } else if ( newY < this.maxScrollY ) {
        newY = this.maxScrollY;
        this.keyAcceleration = 0;
      }

      this.scrollTo(newX, newY, 0);

      this.keyTime = now;
    },

    _animate: function (destX, destY, duration, easingFn) {
      var that = this,
        startX = this.x,
        startY = this.y,
        startTime = utils.getTime(),
        destTime = startTime + duration;

      function step () {
        var now = utils.getTime(),
          newX, newY,
          easing;

        if ( now >= destTime ) {
          that.isAnimating = false;
          that._translate(destX, destY);

          if ( !that.resetPosition(that.options.bounceTime) ) {
            that._execEvent('scrollEnd');
          }

          return;
        }

        now = ( now - startTime ) / duration;
        easing = easingFn(now);
        newX = ( destX - startX ) * easing + startX;
        newY = ( destY - startY ) * easing + startY;
        that._translate(newX, newY);

        if ( that.isAnimating ) {
          rAF(step);
        }
      }

      this.isAnimating = true;
      step();
    },
    handleEvent: function (e) {
      switch ( e.type ) {
        case 'touchstart':
        case 'pointerdown':
        case 'MSPointerDown':
        case 'mousedown':
          this._start(e);
          break;
        case 'touchmove':
        case 'pointermove':
        case 'MSPointerMove':
        case 'mousemove':
          this._move(e);
          break;
        case 'touchend':
        case 'pointerup':
        case 'MSPointerUp':
        case 'mouseup':
        case 'touchcancel':
        case 'pointercancel':
        case 'MSPointerCancel':
        case 'mousecancel':
          this._end(e);
          break;
        case 'orientationchange':
        case 'resize':
          this._resize();
          break;
        case 'transitionend':
        case 'webkitTransitionEnd':
        case 'oTransitionEnd':
        case 'MSTransitionEnd':
          this._transitionEnd(e);
          break;
        case 'wheel':
        case 'DOMMouseScroll':
        case 'mousewheel':
          this._wheel(e);
          break;
        case 'keydown':
          this._key(e);
          break;
        case 'click':
          if ( this.enabled && !e._constructed ) {
            e.preventDefault();
            e.stopPropagation();
          }
          break;
      }
    }
  };
  function createDefaultScrollbar (direction, interactive, type) {
    var scrollbar = document.createElement('div'),
      indicator = document.createElement('div');

    if ( type === true ) {
      scrollbar.style.cssText = 'position:absolute;z-index:9999';
      indicator.style.cssText = '-webkit-box-sizing:border-box;-moz-box-sizing:border-box;box-sizing:border-box;position:absolute;background:rgba(0,0,0,0);border:1px solid rgba(255,255,255,0);border-radius:3px';
    }

    indicator.className = 'iScrollIndicator';

    if ( direction == 'h' ) {
      if ( type === true ) {
        scrollbar.style.cssText += ';height:7px;left:2px;right:2px;bottom:0';
        indicator.style.height = '100%';
      }
      scrollbar.className = 'iScrollHorizontalScrollbar';
    } else {
      if ( type === true ) {
        scrollbar.style.cssText += ';width:7px;bottom:2px;top:2px;right:1px';
        indicator.style.width = '100%';
      }
      scrollbar.className = 'iScrollVerticalScrollbar';
    }

    scrollbar.style.cssText += ';overflow:hidden';

    if ( !interactive ) {
      scrollbar.style.pointerEvents = 'none';
    }

    scrollbar.appendChild(indicator);

    return scrollbar;
  }

  function Indicator (scroller, options) {
    this.wrapper = typeof options.el == 'string' ? document.querySelector(options.el) : options.el;
    this.wrapperStyle = this.wrapper.style;
    this.indicator = this.wrapper.children[0];
    this.indicatorStyle = this.indicator.style;
    this.scroller = scroller;

    this.options = {
      listenX: true,
      listenY: true,
      interactive: false,
      resize: true,
      defaultScrollbars: false,
      shrink: false,
      fade: false,
      speedRatioX: 0,
      speedRatioY: 0
    };

    for ( var i in options ) {
      this.options[i] = options[i];
    }

    this.sizeRatioX = 1;
    this.sizeRatioY = 1;
    this.maxPosX = 0;
    this.maxPosY = 0;

    if ( this.options.interactive ) {
      if ( !this.options.disableTouch ) {
        utils.addEvent(this.indicator, 'touchstart', this);
        utils.addEvent(window, 'touchend', this);
      }
      if ( !this.options.disablePointer ) {
        utils.addEvent(this.indicator, utils.prefixPointerEvent('pointerdown'), this);
        utils.addEvent(window, utils.prefixPointerEvent('pointerup'), this);
      }
      if ( !this.options.disableMouse ) {
        utils.addEvent(this.indicator, 'mousedown', this);
        utils.addEvent(window, 'mouseup', this);
      }
    }

    if ( this.options.fade ) {
      this.wrapperStyle[utils.style.transform] = this.scroller.translateZ;
      var durationProp = utils.style.transitionDuration;
      if(!durationProp) {
        return;
      }
      this.wrapperStyle[durationProp] = utils.isBadAndroid ? '0.0001ms' : '0ms';
      // remove 0.0001ms
      var self = this;
      if(utils.isBadAndroid) {
        rAF(function() {
          if(self.wrapperStyle[durationProp] === '0.0001ms') {
            self.wrapperStyle[durationProp] = '0s';
          }
        });
      }
      this.wrapperStyle.opacity = '0';
    }
  }

  Indicator.prototype = {
    handleEvent: function (e) {
      switch ( e.type ) {
        case 'touchstart':
        case 'pointerdown':
        case 'MSPointerDown':
        case 'mousedown':
          this._start(e);
          break;
        case 'touchmove':
        case 'pointermove':
        case 'MSPointerMove':
        case 'mousemove':
          this._move(e);
          break;
        case 'touchend':
        case 'pointerup':
        case 'MSPointerUp':
        case 'mouseup':
        case 'touchcancel':
        case 'pointercancel':
        case 'MSPointerCancel':
        case 'mousecancel':
          this._end(e);
          break;
      }
    },

    destroy: function () {
      if ( this.options.fadeScrollbars ) {
        clearTimeout(this.fadeTimeout);
        this.fadeTimeout = null;
      }
      if ( this.options.interactive ) {
        utils.removeEvent(this.indicator, 'touchstart', this);
        utils.removeEvent(this.indicator, utils.prefixPointerEvent('pointerdown'), this);
        utils.removeEvent(this.indicator, 'mousedown', this);

        utils.removeEvent(window, 'touchmove', this);
        utils.removeEvent(window, utils.prefixPointerEvent('pointermove'), this);
        utils.removeEvent(window, 'mousemove', this);

        utils.removeEvent(window, 'touchend', this);
        utils.removeEvent(window, utils.prefixPointerEvent('pointerup'), this);
        utils.removeEvent(window, 'mouseup', this);
      }

      if ( this.options.defaultScrollbars ) {
        this.wrapper.parentNode.removeChild(this.wrapper);
      }
    },

    _start: function (e) {
      var point = e.touches ? e.touches[0] : e;

      e.preventDefault();
      e.stopPropagation();

      this.transitionTime();

      this.initiated = true;
      this.moved = false;
      this.lastPointX = point.pageX;
      this.lastPointY = point.pageY;

      this.startTime  = utils.getTime();

      if ( !this.options.disableTouch ) {
        utils.addEvent(window, 'touchmove', this);
      }
      if ( !this.options.disablePointer ) {
        utils.addEvent(window, utils.prefixPointerEvent('pointermove'), this);
      }
      if ( !this.options.disableMouse ) {
        utils.addEvent(window, 'mousemove', this);
      }

      this.scroller._execEvent('beforeScrollStart');
    },

    _move: function (e) {
      var point = e.touches ? e.touches[0] : e,
        deltaX, deltaY,
        newX, newY,
        timestamp = utils.getTime();

      if ( !this.moved ) {
        this.scroller._execEvent('scrollStart');
      }

      this.moved = true;

      deltaX = point.pageX - this.lastPointX;
      this.lastPointX = point.pageX;

      deltaY = point.pageY - this.lastPointY;
      this.lastPointY = point.pageY;

      newX = this.x + deltaX;
      newY = this.y + deltaY;

      this._pos(newX, newY);

      // INSERT POINT: indicator._move

      e.preventDefault();
      e.stopPropagation();
    },

    _end: function (e) {
      if ( !this.initiated ) {
        return;
      }

      this.initiated = false;

      e.preventDefault();
      e.stopPropagation();

      utils.removeEvent(window, 'touchmove', this);
      utils.removeEvent(window, utils.prefixPointerEvent('pointermove'), this);
      utils.removeEvent(window, 'mousemove', this);

      if ( this.scroller.options.snap ) {
        var snap = this.scroller._nearestSnap(this.scroller.x, this.scroller.y);

        var time = this.options.snapSpeed || Math.max(
          Math.max(
            Math.min(Math.abs(this.scroller.x - snap.x), 1000),
            Math.min(Math.abs(this.scroller.y - snap.y), 1000)
          ), 300);

        if ( this.scroller.x != snap.x || this.scroller.y != snap.y ) {
          this.scroller.directionX = 0;
          this.scroller.directionY = 0;
          this.scroller.currentPage = snap;
          this.scroller.scrollTo(snap.x, snap.y, time, this.scroller.options.bounceEasing);
        }
      }

      if ( this.moved ) {
        this.scroller._execEvent('scrollEnd');
      }
    },

    transitionTime: function (time) {
      time = time || 0;
      var durationProp = utils.style.transitionDuration;
      if(!durationProp) {
        return;
      }

      this.indicatorStyle[durationProp] = time + 'ms';

      if ( !time && utils.isBadAndroid ) {
        this.indicatorStyle[durationProp] = '0.0001ms';
        // remove 0.0001ms
        var self = this;
        rAF(function() {
          if(self.indicatorStyle[durationProp] === '0.0001ms') {
            self.indicatorStyle[durationProp] = '0s';
          }
        });
      }
    },

    transitionTimingFunction: function (easing) {
      this.indicatorStyle[utils.style.transitionTimingFunction] = easing;
    },

    refresh: function () {
      this.transitionTime();

      if ( this.options.listenX && !this.options.listenY ) {
        this.indicatorStyle.display = this.scroller.hasHorizontalScroll ? 'block' : 'none';
      } else if ( this.options.listenY && !this.options.listenX ) {
        this.indicatorStyle.display = this.scroller.hasVerticalScroll ? 'block' : 'none';
      } else {
        this.indicatorStyle.display = this.scroller.hasHorizontalScroll || this.scroller.hasVerticalScroll ? 'block' : 'none';
      }

      if ( this.scroller.hasHorizontalScroll && this.scroller.hasVerticalScroll ) {
        utils.addClass(this.wrapper, 'iScrollBothScrollbars');
        utils.removeClass(this.wrapper, 'iScrollLoneScrollbar');

        if ( this.options.defaultScrollbars && this.options.customStyle ) {
          if ( this.options.listenX ) {
            this.wrapper.style.right = '8px';
          } else {
            this.wrapper.style.bottom = '8px';
          }
        }
      } else {
        utils.removeClass(this.wrapper, 'iScrollBothScrollbars');
        utils.addClass(this.wrapper, 'iScrollLoneScrollbar');

        if ( this.options.defaultScrollbars && this.options.customStyle ) {
          if ( this.options.listenX ) {
            this.wrapper.style.right = '2px';
          } else {
            this.wrapper.style.bottom = '2px';
          }
        }
      }

      var r = this.wrapper.offsetHeight;  // force refresh

      if ( this.options.listenX ) {
        this.wrapperWidth = this.wrapper.clientWidth;
        if ( this.options.resize ) {
          this.indicatorWidth = Math.max(Math.round(this.wrapperWidth * this.wrapperWidth / (this.scroller.scrollerWidth || this.wrapperWidth || 1)), 8);
          this.indicatorStyle.width = this.indicatorWidth + 'px';
        } else {
          this.indicatorWidth = this.indicator.clientWidth;
        }

        this.maxPosX = this.wrapperWidth - this.indicatorWidth;

        if ( this.options.shrink == 'clip' ) {
          this.minBoundaryX = -this.indicatorWidth + 8;
          this.maxBoundaryX = this.wrapperWidth - 8;
        } else {
          this.minBoundaryX = 0;
          this.maxBoundaryX = this.maxPosX;
        }

        this.sizeRatioX = this.options.speedRatioX || (this.scroller.maxScrollX && (this.maxPosX / this.scroller.maxScrollX));
      }

      if ( this.options.listenY ) {
        this.wrapperHeight = this.wrapper.clientHeight;
        if ( this.options.resize ) {
          this.indicatorHeight = Math.max(Math.round(this.wrapperHeight * this.wrapperHeight / (this.scroller.scrollerHeight || this.wrapperHeight || 1)), 8);
          this.indicatorStyle.height = this.indicatorHeight + 'px';
        } else {
          this.indicatorHeight = this.indicator.clientHeight;
        }

        this.maxPosY = this.wrapperHeight - this.indicatorHeight;

        if ( this.options.shrink == 'clip' ) {
          this.minBoundaryY = -this.indicatorHeight + 8;
          this.maxBoundaryY = this.wrapperHeight - 8;
        } else {
          this.minBoundaryY = 0;
          this.maxBoundaryY = this.maxPosY;
        }

        this.maxPosY = this.wrapperHeight - this.indicatorHeight;
        this.sizeRatioY = this.options.speedRatioY || (this.scroller.maxScrollY && (this.maxPosY / this.scroller.maxScrollY));
      }

      this.updatePosition();
    },

    updatePosition: function () {
      var x = this.options.listenX && Math.round(this.sizeRatioX * this.scroller.x) || 0,
        y = this.options.listenY && Math.round(this.sizeRatioY * this.scroller.y) || 0;

      if ( !this.options.ignoreBoundaries ) {
        if ( x < this.minBoundaryX ) {
          if ( this.options.shrink == 'scale' ) {
            this.width = Math.max(this.indicatorWidth + x, 8);
            this.indicatorStyle.width = this.width + 'px';
          }
          x = this.minBoundaryX;
        } else if ( x > this.maxBoundaryX ) {
          if ( this.options.shrink == 'scale' ) {
            this.width = Math.max(this.indicatorWidth - (x - this.maxPosX), 8);
            this.indicatorStyle.width = this.width + 'px';
            x = this.maxPosX + this.indicatorWidth - this.width;
          } else {
            x = this.maxBoundaryX;
          }
        } else if ( this.options.shrink == 'scale' && this.width != this.indicatorWidth ) {
          this.width = this.indicatorWidth;
          this.indicatorStyle.width = this.width + 'px';
        }

        if ( y < this.minBoundaryY ) {
          if ( this.options.shrink == 'scale' ) {
            this.height = Math.max(this.indicatorHeight + y * 3, 8);
            this.indicatorStyle.height = this.height + 'px';
          }
          y = this.minBoundaryY;
        } else if ( y > this.maxBoundaryY ) {
          if ( this.options.shrink == 'scale' ) {
            this.height = Math.max(this.indicatorHeight - (y - this.maxPosY) * 3, 8);
            this.indicatorStyle.height = this.height + 'px';
            y = this.maxPosY + this.indicatorHeight - this.height;
          } else {
            y = this.maxBoundaryY;
          }
        } else if ( this.options.shrink == 'scale' && this.height != this.indicatorHeight ) {
          this.height = this.indicatorHeight;
          this.indicatorStyle.height = this.height + 'px';
        }
      }

      this.x = x;
      this.y = y;

      if ( this.scroller.options.useTransform ) {
        this.indicatorStyle[utils.style.transform] = 'translate(' + x + 'px,' + y + 'px)' + this.scroller.translateZ;
      } else {
        this.indicatorStyle.left = x + 'px';
        this.indicatorStyle.top = y + 'px';
      }
    },

    _pos: function (x, y) {
      if ( x < 0 ) {
        x = 0;
      } else if ( x > this.maxPosX ) {
        x = this.maxPosX;
      }

      if ( y < 0 ) {
        y = 0;
      } else if ( y > this.maxPosY ) {
        y = this.maxPosY;
      }

      x = this.options.listenX ? Math.round(x / this.sizeRatioX) : this.scroller.x;
      y = this.options.listenY ? Math.round(y / this.sizeRatioY) : this.scroller.y;

      this.scroller.scrollTo(x, y);
    },

    fade: function (val, hold) {
      if ( hold && !this.visible ) {
        return;
      }

      clearTimeout(this.fadeTimeout);
      this.fadeTimeout = null;

      var time = val ? 250 : 500,
        delay = val ? 0 : 300;

      val = val ? '1' : '0';

      this.wrapperStyle[utils.style.transitionDuration] = time + 'ms';

      this.fadeTimeout = setTimeout((function (val) {
        this.wrapperStyle.opacity = val;
        this.visible = +val;
      }).bind(this, val), delay);
    }
  };

  IScroll.utils = utils;

  if ( typeof module != 'undefined' && module.exports ) {
    module.exports = IScroll;
  } else if ( typeof define == 'function' && define.amd ) {
    define( function () { return IScroll; } );
  } else {
    window.IScroll = IScroll;
  }

})(window, document, Math);

/*!
 * fullPage ScrollOverflow
 * https://github.com/alvarotrigo/fullPage.js
 * @license MIT licensed
 *
 * Copyright (C) 2015 alvarotrigo.com - A project by Alvaro Trigo
 */
(function(window, $) {
  var ACTIVE =                'active';
  var ACTIVE_SEL =            '.' + ACTIVE;

  var SECTION =               'fp-section';
  var SECTION_SEL =           '.' + SECTION;
  var SECTION_ACTIVE_SEL =    SECTION_SEL + ACTIVE_SEL;

  var SLIDE =                 'fp-slide';
  var SLIDE_SEL =             '.' + SLIDE;
  var SLIDE_ACTIVE_SEL =      SLIDE_SEL + ACTIVE_SEL;
  var SLIDES_WRAPPER =        'fp-slides';
  var SLIDES_WRAPPER_SEL =    '.' + SLIDES_WRAPPER;

  // scrolloverflow
  var SCROLLABLE =            'fp-scrollable';
  var SCROLLABLE_SEL =        '.' + SCROLLABLE;

  if(typeof IScroll !== 'undefined'){
    /*
    * Turns iScroll `mousewheel` option off dynamically
    * https://github.com/cubiq/iscroll/issues/1036
    */
    IScroll.prototype.wheelOn = function () {
      this.wrapper.addEventListener('wheel', this);
      this.wrapper.addEventListener('mousewheel', this);
      this.wrapper.addEventListener('DOMMouseScroll', this);
    };

    /*
    * Turns iScroll `mousewheel` option on dynamically
    * https://github.com/cubiq/iscroll/issues/1036
    */
    IScroll.prototype.wheelOff = function () {
      this.wrapper.removeEventListener('wheel', this);
      this.wrapper.removeEventListener('mousewheel', this);
      this.wrapper.removeEventListener('DOMMouseScroll', this);
    };
  }

  /**
   * An object to handle overflow scrolling.
   * This uses jquery.slimScroll to accomplish overflow scrolling.
   * It is possible to pass in an alternate scrollOverflowHandler
   * to the fullpage.js option that implements the same functions
   * as this handler.
   *
   * @type {Object}
   */
  window.iscrollHandler = {
    refreshId: null,
    iScrollInstances: [],

    // Enables or disables the mouse wheel for the active section or all slides in it
    toggleWheel: function(value){
      var scrollable = $(SECTION_ACTIVE_SEL).find(SCROLLABLE_SEL);
      scrollable.each(function(){
        var iScrollInstance = $(this).data('iscrollInstance');
        if(typeof iScrollInstance !== 'undefined' && iScrollInstance){
          if(value){
            iScrollInstance.wheelOn();
          }
          else{
            iScrollInstance.wheelOff();
          }
        }
      });
    },

    /**
     * Turns off iScroll for the destination section.
     * When scrolling very fast on some trackpads (and Apple laptops) the inertial scrolling would
     * scroll the destination section/slide before the sections animations ends.
     */
    onLeave: function(){
      iscrollHandler.toggleWheel(false);
    },

    // Turns off iScroll for the leaving section
    beforeLeave: function(){
      iscrollHandler.onLeave()
    },

    // Turns on iScroll on section load
    afterLoad: function(){
      iscrollHandler.toggleWheel(true);
    },

    /**
     * Called when overflow scrolling is needed for a section.
     *
     * @param  {Object} element      jQuery object containing current section
     * @param  {Number} scrollHeight Current window height in pixels
     */
    create: function(element, scrollHeight, scrollOverflowOptions) {
      var scrollable = element.find(SCROLLABLE_SEL);

      scrollable.height(scrollHeight);
      scrollable.each(function() {
        var $this = $(this);
        var iScrollInstance = $this.data('iscrollInstance');
        if (iScrollInstance) {
          $.each(iscrollHandler.iScrollInstances, function(){
            $(this).destroy();
          });
        }

        iScrollInstance = new IScroll($this.get(0), scrollOverflowOptions);

        iScrollInstance.on('scrollEnd', function() {
          this['fp_isAtTop'] = this.y > -30;
          this['fp_isAtEnd'] = this.y - this.maxScrollY < 30;
        });

        iscrollHandler.iScrollInstances.push(iScrollInstance);

        //off by default until the section gets active
        iScrollInstance.wheelOff();

        $this.data('iscrollInstance', iScrollInstance);
      });
    },

    /**
     * Return a boolean depending on whether the scrollable element is a
     * the end or at the start of the scrolling depending on the given type.
     *
     * @param  {String}  type       Either 'top' or 'bottom'
     * @param  {Object}  scrollable jQuery object for the scrollable element
     * @return {Boolean}
     */
    isScrolled: function(type, scrollable) {
      var scroller = scrollable.data('iscrollInstance');

      //no scroller?
      if (!scroller) {
        return true;
      }

      if (type === 'top') {
        return scroller.y >= 0 && !scrollable.scrollTop();
      } else if (type === 'bottom') {
        return (0 - scroller.y) + scrollable.scrollTop() + 1 + scrollable.innerHeight() >= scrollable[0].scrollHeight;
      }
    },

    /**
     * Returns the scrollable element for the given section.
     * If there are landscape slides, will only return a scrollable element
     * if it is in the active slide.
     *
     * @param  {Object}  activeSection jQuery object containing current section
     * @return {Boolean}
     */
    scrollable: function(activeSection){
      // if there are landscape slides, we check if the scrolling bar is in the current one or not
      if (activeSection.find(SLIDES_WRAPPER_SEL).length) {
        return activeSection.find(SLIDE_ACTIVE_SEL).find(SCROLLABLE_SEL);
      }
      return activeSection.find(SCROLLABLE_SEL);
    },

    /**
     * Returns the scroll height of the wrapped content.
     * If this is larger than the window height minus section padding,
     * overflow scrolling is needed.
     *
     * @param  {Object} element jQuery object containing current section
     * @return {Number}
     */
    scrollHeight: function(element) {
      return element.find(SCROLLABLE_SEL).children().first().get(0).scrollHeight;
    },

    /**
     * Called when overflow scrolling is no longer needed for a section.
     *
     * @param  {Object} element      jQuery object containing current section
     */
    remove: function(element) {
      var scrollable = element.find(SCROLLABLE_SEL);
      if (scrollable.length) {
        var iScrollInstance = scrollable.data('iscrollInstance');
        if(iScrollInstance){
          iScrollInstance.destroy();
        }

        scrollable.data('iscrollInstance', null);
      }
      element.find(SCROLLABLE_SEL).children().first().children().first().unwrap().unwrap();
    },

    /**
     * Called when overflow scrolling has already been setup but the
     * window height has potentially changed.
     *
     * @param  {Object} element      jQuery object containing current section
     * @param  {Number} scrollHeight Current window height in pixels
     */
    update: function(element, scrollHeight) {
      //using a timeout in order to execute the refresh function only once when `update` is called multiple times in a
      //short period of time.
      //it also comes on handy because iScroll requires the use of timeout when using `refresh`.
      clearTimeout(iscrollHandler.refreshId);
      iscrollHandler.refreshId = setTimeout(function(){
        $.each(iscrollHandler.iScrollInstances, function(){
          $(this).get(0).refresh();
        });
      }, 150);

      //updating the wrappers height
      element.find(SCROLLABLE_SEL).css('height', scrollHeight + 'px').parent().css('height', scrollHeight + 'px');
    },

    /**
     * Called to get any additional elements needed to wrap the section
     * content in order to facilitate overflow scrolling.
     *
     * @return {String|Object} Can be a string containing HTML,
     *                         a DOM element, or jQuery object.
     */
    wrapContent: function() {
      return '<div class="' + SCROLLABLE + '"><div class="fp-scroller"></div></div>';
    }
  };
})(window, jQuery);


// scrolloverflow module
(function (window, document, $) {
  $.fn.fp_scrolloverflow = (function() {

    // keeping central set of classnames and selectors
    var SCROLLABLE =            'fp-scrollable';
    var SCROLLABLE_SEL =        '.' + SCROLLABLE;

    var ACTIVE =                'active';
    var ACTIVE_SEL =            '.' + ACTIVE;

    var SECTION =               'fp-section';
    var SECTION_SEL =           '.' + SECTION;
    var SECTION_ACTIVE_SEL =    SECTION_SEL + ACTIVE_SEL;

    var SLIDE =                 'fp-slide';
    var SLIDE_SEL =             '.' + SLIDE;
    var SLIDE_ACTIVE_SEL =      SLIDE_SEL + ACTIVE_SEL;

    var SLIDES_WRAPPER =        'fp-slides';
    var SLIDES_WRAPPER_SEL =    '.' + SLIDES_WRAPPER;

    var TABLE_CELL =            'fp-tableCell';
    var TABLE_CELL_SEL =        '.' + TABLE_CELL;

    var RESPONSIVE =            'fp-responsive';
    var AUTO_HEIGHT_RESPONSIVE= 'fp-auto-height-responsive';

    /*
    * Turns iScroll `mousewheel` option off dynamically
    * https://github.com/cubiq/iscroll/issues/1036
    */
    IScroll.prototype.wheelOn = function () {
      this.wrapper.addEventListener('wheel', this);
      this.wrapper.addEventListener('mousewheel', this);
      this.wrapper.addEventListener('DOMMouseScroll', this);
    };

    /*
    * Turns iScroll `mousewheel` option on dynamically
    * https://github.com/cubiq/iscroll/issues/1036
    */
    IScroll.prototype.wheelOff = function () {
      this.wrapper.removeEventListener('wheel', this);
      this.wrapper.removeEventListener('mousewheel', this);
      this.wrapper.removeEventListener('DOMMouseScroll', this);
    };


    function scrollBarHandler(){
      var self = this;
      self.options = null;

      self.init = function(options, iscrollOptions){
        self.options = options;
        self.iscrollOptions = iscrollOptions;

        if(document.readyState === 'complete'){
          createScrollBarForAll();
          $.fn.fullpage.shared.afterRenderActions();
        }
        //after DOM and images are loaded
        $(window).on('load', function(){
          createScrollBarForAll();
          $.fn.fullpage.shared.afterRenderActions();
        });

        return self;
      };

      /**
       * Creates the scrollbar for the sections and slides in the site
       */
      function createScrollBarForAll(){
        if($('body').hasClass(RESPONSIVE)){
          removeResponsiveScrollOverflows();
        }
        else{
          forEachSectionAndSlide(createScrollBar);
        }
      }

      /**
       * Checks if the element needs scrollbar and if the user wants to apply it.
       * If so it creates it.
       *
       * @param {Object} element   jQuery object of the section or slide
       */
      function createScrollBar(element){
        //User doesn't want scrollbar here? Sayonara baby!
        if(element.hasClass('fp-noscroll')) return;

        //necessary to make `scrollHeight` work under Opera 12
        element.css('overflow', 'hidden');

        var scrollOverflowHandler = self.options.scrollOverflowHandler;
        var wrap = scrollOverflowHandler.wrapContent();
        var section = element.closest(SECTION_SEL); //in case element is a slide
        var scrollable = scrollOverflowHandler.scrollable(element);
        var contentHeight;
        var paddings = parseInt(section.css('padding-bottom')) + parseInt(section.css('padding-top'));

        //if there was scroll, the contentHeight will be the one in the scrollable section
        if(scrollable.length){
          contentHeight = scrollOverflowHandler.scrollHeight(element);
        }
        else{
          contentHeight = element.get(0).scrollHeight - paddings;
          if(self.options.verticalCentered){
            contentHeight = element.find(TABLE_CELL_SEL).get(0).scrollHeight - paddings;
          }
        }

        var scrollHeight = $(window).height() - paddings;

        //needs scroll?
        if ( contentHeight > scrollHeight) {
          //did we already have an scrollbar ? Updating it
          if(scrollable.length){
            scrollOverflowHandler.update(element, scrollHeight);
          }
          //creating the scrolling
          else{
            if(self.options.verticalCentered){
              element.find(TABLE_CELL_SEL).wrapInner(wrap);
            }else{
              element.wrapInner(wrap);
            }
            scrollOverflowHandler.create(element, scrollHeight, self.iscrollOptions);
          }
        }
        //removing the scrolling when it is not necessary anymore
        else{
          scrollOverflowHandler.remove(element);
        }

        //undo
        element.css('overflow', '');
      }

      /**
       * Applies a callback function to each section in the site
       * or the slides within them
       */
      function forEachSectionAndSlide(callback){
        $(SECTION_SEL).each(function(){
          var slides = $(this).find(SLIDE_SEL);

          if(slides.length){
            slides.each(function(){
              callback($(this));
            });
          }else{
            callback($(this));
          }
        });
      }

      /**
       * Removes scrollOverflow for sections using the class `fp-auto-height-responsive`
       */
      function removeResponsiveScrollOverflows(){
        var scrollOverflowHandler = self.options.scrollOverflowHandler;
        forEachSectionAndSlide(function(element){
          if(element.closest(SECTION_SEL).hasClass(AUTO_HEIGHT_RESPONSIVE)){
            scrollOverflowHandler.remove(element);
          }
        });
      }

      //public functions
      self.createScrollBarForAll = createScrollBarForAll;
    }

    /**
     * An object to handle overflow scrolling.
     * This uses jquery.slimScroll to accomplish overflow scrolling.
     * It is possible to pass in an alternate scrollOverflowHandler
     * to the fullpage.js option that implements the same functions
     * as this handler.
     *
     * @type {Object}
     */
    var iscrollHandler = {
      refreshId: null,
      iScrollInstances: [],

      // Default options for iScroll.js used when using scrollOverflow
      iscrollOptions: {
        scrollbars: true,
        mouseWheel: true,
        hideScrollbars: false,
        fadeScrollbars: false,
        disableMouse: true,
        interactiveScrollbars: true
      },

      init: function(options){
        var isTouch = (('ontouchstart' in window) || (navigator.msMaxTouchPoints > 0) || (navigator.maxTouchPoints));

        //fixing bug in iScroll with links: https://github.com/cubiq/iscroll/issues/783
        iscrollHandler.iscrollOptions.click = isTouch; // see #2035

        //extending iScroll options with the user custom ones
        iscrollHandler.iscrollOptions = $.extend(iscrollHandler.iscrollOptions, options.scrollOverflowOptions);

        return new scrollBarHandler().init(options, iscrollHandler.iscrollOptions);
      },

      // Enables or disables the mouse wheel for the active section or all slides in it
      toggleWheel: function(value){
        var scrollable = $(SECTION_ACTIVE_SEL).find(SCROLLABLE_SEL);
        scrollable.each(function(){
          var iScrollInstance = $(this).data('iscrollInstance');
          if(typeof iScrollInstance !== 'undefined' && iScrollInstance){
            if(value){
              iScrollInstance.wheelOn();
            }
            else{
              iScrollInstance.scrollTo(0, 0);
              iScrollInstance.wheelOff();
            }
          }
        });
      },

      /**
       * Turns off iScroll for the destination section.
       * When scrolling very fast on some trackpads (and Apple laptops) the inertial scrolling would
       * scroll the destination section/slide before the sections animations ends.
       */
      onLeave: function(){
        iscrollHandler.toggleWheel(false);
      },

      // Turns off iScroll for the leaving section
      beforeLeave: function(){
        iscrollHandler.onLeave()
      },

      // Turns on iScroll on section load
      afterLoad: function(){
        iscrollHandler.toggleWheel(true);
      },

      /**
       * Called when overflow scrolling is needed for a section.
       *
       * @param  {Object} element      jQuery object containing current section
       * @param  {Number} scrollHeight Current window height in pixels
       */
      create: function(element, scrollHeight, iscrollOptions) {
        var scrollable = element.find(SCROLLABLE_SEL);

        scrollable.height(scrollHeight);
        scrollable.each(function() {
          var $this = $(this);
          var iScrollInstance = $this.data('iscrollInstance');
          if (iScrollInstance) {
            $.each(iscrollHandler.iScrollInstances, function(){
              $(this).destroy();
            });
          }

          iScrollInstance = new IScroll($this.get(0), iscrollOptions);
          iscrollHandler.iScrollInstances.push(iScrollInstance);

          //off by default until the section gets active
          iScrollInstance.wheelOff();

          $this.data('iscrollInstance', iScrollInstance);
        });
      },

      /**
       * Return a boolean depending on whether the scrollable element is a
       * the end or at the start of the scrolling depending on the given type.
       *
       * @param  {String}  type       Either 'top' or 'bottom'
       * @param  {Object}  scrollable jQuery object for the scrollable element
       * @return {Boolean}
       */
      isScrolled: function(type, scrollable) {
        var scroller = scrollable.data('iscrollInstance');

        //no scroller?
        if (!scroller) {
          return true;
        }

        if (type === 'top') {
          return scroller.y >= 0 && !scrollable.scrollTop();
        } else if (type === 'bottom') {
          return (0 - scroller.y) + scrollable.scrollTop() + 1 + scrollable.innerHeight() >= scrollable[0].scrollHeight;
        }
      },

      /**
       * Returns the scrollable element for the given section.
       * If there are landscape slides, will only return a scrollable element
       * if it is in the active slide.
       *
       * @param  {Object}  activeSection jQuery object containing current section
       * @return {Boolean}
       */
      scrollable: function(activeSection){
        // if there are landscape slides, we check if the scrolling bar is in the current one or not
        if (activeSection.find(SLIDES_WRAPPER_SEL).length) {
          return activeSection.find(SLIDE_ACTIVE_SEL).find(SCROLLABLE_SEL);
        }
        return activeSection.find(SCROLLABLE_SEL);
      },

      /**
       * Returns the scroll height of the wrapped content.
       * If this is larger than the window height minus section padding,
       * overflow scrolling is needed.
       *
       * @param  {Object} element jQuery object containing current section
       * @return {Number}
       */
      scrollHeight: function(element) {
        return element.find(SCROLLABLE_SEL).children().first().get(0).scrollHeight;
      },

      /**
       * Called when overflow scrolling is no longer needed for a section.
       *
       * @param  {Object} element      jQuery object containing current section
       */
      remove: function(element) {
        var scrollable = element.find(SCROLLABLE_SEL);
        if (scrollable.length) {
          var iScrollInstance = scrollable.data('iscrollInstance');
          iScrollInstance.destroy();

          scrollable.data('iscrollInstance', null);
        }
        element.find(SCROLLABLE_SEL).children().first().children().first().unwrap().unwrap();
      },

      /**
       * Called when overflow scrolling has already been setup but the
       * window height has potentially changed.
       *
       * @param  {Object} element      jQuery object containing current section
       * @param  {Number} scrollHeight Current window height in pixels
       */
      update: function(element, scrollHeight) {
        //using a timeout in order to execute the refresh function only once when `update` is called multiple times in a
        //short period of time.
        //it also comes on handy because iScroll requires the use of timeout when using `refresh`.
        clearTimeout(iscrollHandler.refreshId);
        iscrollHandler.refreshId = setTimeout(function(){
          $.each(iscrollHandler.iScrollInstances, function(){
            $(this).get(0).refresh();
          });
        }, 150);

        //updating the wrappers height
        element.find(SCROLLABLE_SEL).css('height', scrollHeight + 'px').parent().css('height', scrollHeight + 'px');
      },

      /**
       * Called to get any additional elements needed to wrap the section
       * content in order to facilitate overflow scrolling.
       *
       * @return {String|Object} Can be a string containing HTML,
       *                         a DOM element, or jQuery object.
       */
      wrapContent: function() {
        return '<div class="' + SCROLLABLE + '"><div class="fp-scroller"></div></div>';
      }
    };

    return {
      iscrollHandler: iscrollHandler
    };
  })();
})(window, document, jQuery);

/*!
 * fullPage 2.9.7 - Extensions 0.1.5
 * https://github.com/alvarotrigo/fullPage.js
 * @license http://alvarotrigo.com/fullPage/extensions/#license
 *
 * Copyright (C) 2015 alvarotrigo.com - A project by Alvaro Trigo
 */
!function(e,n){"use strict";"function"==typeof define&&define.amd?define(["web/libraries/spectrum/test/jquery"],function(t){return n(t,e,e.document,e.Math)}):"object"==typeof exports&&exports?module.exports=n(require("web/libraries/spectrum/test/jquery"),e,e.document,e.Math):n(jQuery,e,e.document,e.Math)}("undefined"!=typeof window?window:this,function(e, n, t, o, i){"use strict";var a="fullpage-wrapper",r="."+a,l="fp-responsive",s="fp-notransition",c="fp-destroyed",d="fp-enabled",f="fp-viewing",u="active",v="."+u,h="fp-completely",p="."+h,g="fp-section",m="."+g,S=m+v,w=m+":first",b=m+":last",x="fp-tableCell",y="."+x,C="fp-auto-height",T="fp-normal-scroll",A="fp-nav",M="#"+A,k="fp-tooltip",O="."+k,R="fp-show-active",z="fp-slide",I="."+z,L=I+v,H="fp-slides",E="."+H,B="fp-slidesContainer",D="."+B,P="fp-table",Y="fp-initial",F="fp-slidesNav",W="."+F,X=W+" a",V="fp-controlArrow",Z="."+V,N="fp-prev",j=V+" "+N,q=Z+("."+N),G="fp-next",U=V+" "+G,Q=Z+".fp-next",J=e(n),K=e(t);e.fn.fullpage=function(V){if(e("html").hasClass(d))kt();else{var G=e("html, body"),_=e("body"),$=e.fn.fullpage;V=e.extend(!0,{menu:!1,anchors:[],lockAnchors:!1,navigation:!1,navigationPosition:"right",navigationTooltips:[],showActiveTooltip:!1,slidesNavigation:!1,slidesNavPosition:"bottom",scrollBar:!1,hybrid:!1,css3:!0,scrollingSpeed:700,autoScrolling:!0,fitToSection:!0,fitToSectionDelay:1e3,easing:"easeInOutCubic",easingcss3:"ease",loopBottom:!1,loopTop:!1,loopHorizontal:!0,continuousVertical:!1,continuousHorizontal:!1,scrollHorizontally:!1,interlockedSlides:!1,dragAndMove:!1,offsetSections:!1,resetSliders:!1,fadingEffect:!1,normalScrollElements:null,scrollOverflow:!1,scrollOverflowReset:!1,scrollOverflowHandler:e.fn.fp_scrolloverflow?e.fn.fp_scrolloverflow.iscrollHandler:null,scrollOverflowOptions:null,touchSensitivity:5,normalScrollElementTouchThreshold:5,bigSectionsDestination:null,keyboardScrolling:!0,animateAnchor:!0,recordHistory:!0,controlArrows:!0,controlArrowColor:"#fff",verticalCentered:!0,sectionsColor:[],paddingTop:0,paddingBottom:0,fixedElements:null,responsive:0,responsiveWidth:0,responsiveHeight:0,responsiveSlides:!1,parallax:!1,parallaxOptions:{type:"reveal",percentage:62,property:"translate"},sectionSelector:".section",slideSelector:".slide",afterLoad:null,onLeave:null,afterRender:null,afterResize:null,afterReBuild:null,afterSlideLoad:null,onSlideLeave:null,afterResponsive:null,lazyLoading:!0},V);var ee,ne,te,oe,ie=!1,ae=navigator.userAgent.match(/(iPhone|iPod|iPad|Android|playbook|silk|BlackBerry|BB10|Windows Phone|Tizen|Bada|webOS|IEMobile|Opera Mini)/),re="ontouchstart"in n||navigator.msMaxTouchPoints>0||navigator.maxTouchPoints,le=e(this),se=J.height(),ce=!1,de=!0,fe=!0,ue=[],ve={m:{up:!0,down:!0,left:!0,right:!0}};ve.k=e.extend(!0,{},ve.m);var he,pe,ge,me,Se,we,be,xe,ye=pt(),Ce={touchmove:"ontouchmove"in n?"touchmove":ye.move,touchstart:"ontouchstart"in n?"touchstart":ye.down},Te=!1,Ae='a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), iframe, object, embed, [tabindex="0"], [contenteditable]',Me=e.extend(!0,{},V),ke={};kt(),e.extend(e.easing,{easeInOutCubic:function(e, n, t, o, i){return(n/=i/2)<1?o/2*n*n*n+t:o/2*((n-=2)*n*n+2)+t}}),e.event.special.destroyed={remove:function(e){e.handler&&e.handler()}},e(this).length&&($.version="2.9.7",$.setAutoScrolling=Ze,$.setRecordHistory=Ne,$.setScrollingSpeed=je,$.setFitToSection=qe,$.setLockAnchors=function(e){V.lockAnchors=e},$.setMouseWheelScrolling=Ge,$.setAllowScrolling=Ue,$.setKeyboardScrolling=Qe,$.moveSectionUp=Je,$.moveSectionDown=Ke,$.silentMoveTo=_e,$.moveTo=$e,$.moveSlideRight=en,$.moveSlideLeft=nn,$.fitToSection=fn,$.reBuild=tn,$.setResponsive=on,$.getFullpageData=function(){return{options:V,internals:{canScroll:fe,isScrollAllowed:ve,getDestinationPosition:xn,isTouch:re,c:Ln,getXmovement:it,removeAnimation:nt,getTransforms:wt,lazyLoad:An,addAnimation:et,performHorizontalMove:Kn,landscapeScroll:Un,silentLandscapeScroll:mt,keepSlidesPosition:bn,silentScroll:St,styleSlides:rn,scrollHandler:cn,getEventsPage:gt,getMSPointer:pt,isReallyTouch:pn,usingExtension:yt,toggleControlArrows:Qn}}},$.destroy=function(n){le.trigger("destroy",[n]),Ze(!1,"internal"),Ue(!1),Qe(!1),le.addClass(c),clearTimeout(me),clearTimeout(ge),clearTimeout(pe),clearTimeout(Se),clearTimeout(we),J.off("scroll",cn).off("hashchange",Dn).off("resize",_n),K.off("keydown",Yn).off("keyup",Wn).off("click touchstart",M+" a").off("mouseenter",M+" li").off("mouseleave",M+" li").off("click touchstart",X).off("mouseover",V.normalScrollElements).off("mouseout",V.normalScrollElements),e(m).off("click touchstart",Z),yt("dragAndMove")&&$.dragAndMove.destroy();clearTimeout(me),clearTimeout(ge),n&&function(){St(0),le.find("img[data-src], source[data-src], audio[data-src], iframe[data-src]").each(function(){Tn(e(this),"src")}),le.find("img[data-srcset]").each(function(){Tn(e(this),"srcset")}),e(M+", "+W+", "+Z).remove(),e(m).css({height:"","background-color":"",padding:""}),e(I).css({width:""}),le.css({height:"",position:"","-ms-touch-action":"","touch-action":""}),G.css({overflow:"",height:""}),e("html").removeClass(d),_.removeClass(l),e.each(_.get(0).className.split(/\s+/),function(e, n){0===n.indexOf(f)&&_.removeClass(n)}),e(m+", "+I).each(function(){V.scrollOverflowHandler&&V.scrollOverflowHandler.remove(e(this)),e(this).removeClass(P+" "+u),e(this).attr("style",e(this).data("fp-styles"))}),xt(le),le.find(y+", "+D+", "+E).each(function(){e(this).replaceWith(this.childNodes)}),G.scrollTop(0);var n=[g,z,B];e.each(n,function(n, t){e("."+t).removeClass(t)})}()},$.landscapeScroll=Un,$.shared={afterRenderActions:sn},an("continuousHorizontal"),an("scrollHorizontally"),an("resetSliders"),an("interlockedSlides"),an("responsiveSlides"),an("fadingEffect"),an("dragAndMove"),an("offsetSections"),an("scrollOverflowReset"),an("parallax"),yt("dragAndMove")&&$.dragAndMove.init(),function(){V.css3&&(V.css3=function(){var e,o=t.createElement("p"),a={webkitTransform:"-webkit-transform",OTransform:"-o-transform",msTransform:"-ms-transform",MozTransform:"-moz-transform",transform:"transform"};for(var r in t.body.insertBefore(o,null),a)o.style[r]!==i&&(o.style[r]="translate3d(1px,1px,1px)",e=n.getComputedStyle(o).getPropertyValue(a[r]));return t.body.removeChild(o),e!==i&&e.length>0&&"none"!==e}());V.scrollBar=V.scrollBar||V.hybrid,o=le.find(V.sectionSelector),V.anchors.length||(V.anchors=o.filter("[data-anchor]").map(function(){return e(this).data("anchor").toString()}).get()),V.navigationTooltips.length||(V.navigationTooltips=o.filter("[data-tooltip]").map(function(){return e(this).data("tooltip").toString()}).get()),le.css({height:"100%",position:"relative"}),le.addClass(a),e("html").addClass(d),se=J.height(),le.removeClass(c),le.find(V.sectionSelector).addClass(g),le.find(V.slideSelector).addClass(z),Ct("parallax","init"),e(m).each(function(n){var t,o,i,a,l=e(this),s=l.find(I),c=s.length;l.data("fp-styles",l.attr("style")),i=l,(a=n)||0!==e(S).length||i.addClass(u),oe=e(S),i.css("height",ln(i)+"px"),V.paddingTop&&i.css("padding-top",V.paddingTop),V.paddingBottom&&i.css("padding-bottom",V.paddingBottom),void 0!==V.sectionsColor[a]&&i.css("background-color",V.sectionsColor[a]),void 0!==V.anchors[a]&&i.attr("data-anchor",V.anchors[a]),t=l,o=n,void 0!==V.anchors[o]&&t.hasClass(u)&&tt(V.anchors[o],o),V.menu&&V.css3&&e(V.menu).closest(r).length&&e(V.menu).appendTo(_),c>0?rn(l,s,c):V.verticalCentered&&at(l)}),V.fixedElements&&V.css3&&e(V.fixedElements).appendTo(_),V.navigation&&function(){_.append('<div id="'+A+'"><ul></ul></div>');var n=e(M);n.addClass(function(){return V.showActiveTooltip?R+" "+V.navigationPosition:V.navigationPosition});for(var t=0; t<e(m).length; t++){var o="";V.anchors.length&&(o=V.anchors[t]);var i='<li><a href="#'+o+'"><span></span></a>',a=V.navigationTooltips[t];void 0!==a&&""!==a&&(i+='<div class="'+k+" "+V.navigationPosition+'">'+a+"</div>"),i+="</li>",n.find("ul").append(i)}e(M).css("margin-top","-"+e(M).height()/2+"px"),e(M).find("li").eq(e(S).index(m)).find("a").addClass(u)}(),le.find('iframe[src*="youtube.com/embed/"]').each(function(){var n,t,o;n=e(this),t="enablejsapi=1",o=n.attr("src"),n.attr("src",o+(/\?/.test(o)?"&":"?")+t)}),V.fadingEffect&&$.fadingEffect&&$.fadingEffect.apply(),V.scrollOverflow?he=V.scrollOverflowHandler.init(V):sn(),Ue(!0),Ze(V.autoScrolling,"internal"),$n(),ht(),"complete"===t.readyState&&Bn();var o;J.on("load",Bn)}(),J.on("scroll",cn).on("hashchange",Dn).blur(Nn).resize(_n),K.keydown(Yn).keyup(Wn).on("click touchstart",M+" a",jn).on("click touchstart",X,qn).on("click",O,Fn),e(m).on("click touchstart",Z,Zn),V.normalScrollElements&&(K.on("mouseenter touchstart",V.normalScrollElements,function(){Ue(!1)}),K.on("mouseleave touchend",V.normalScrollElements,function(){Ue(!0)})),yt("dragAndMove")&&$.dragAndMove.turnOffTouch());var Oe,Re=!1,ze=0,Ie=0,Le=0,He=0,Ee=0;Oe=n.requestAnimationFrame||n.mozRequestAnimationFrame||n.webkitRequestAnimationFrame||n.msRequestAnimationFrame,n.requestAnimationFrame=Oe;var Be,De,Pe,Ye=(new Date).getTime(),Fe=!1,We=0,Xe=0,Ve=se}function Ze(n, t){n||St(0),Mt("autoScrolling",n,t);var o=e(S);V.autoScrolling&&!V.scrollBar?(G.css({overflow:"hidden",height:"100%"}),Ne(Me.recordHistory,"internal"),le.css({"-ms-touch-action":"none","touch-action":"none"}),o.length&&St(o.position().top)):(G.css({overflow:"visible",height:"initial"}),Ne(!1,"internal"),le.css({"-ms-touch-action":"","touch-action":""}),xt(le),o.length&&G.scrollTop(o.position().top)),le.trigger("setAutoScrolling",[n])}function Ne(e, n){Mt("recordHistory",e,n)}function je(e, n){"internal"!==n&&V.fadingEffect&&$.fadingEffect&&$.fadingEffect.update(e),Mt("scrollingSpeed",e,n)}function qe(e, n){Mt("fitToSection",e,n)}function Ge(e){e?(!function(){var e,o="";n.addEventListener?e="addEventListener":(e="attachEvent",o="on");var a="onwheel"in t.createElement("div")?"wheel":t.onmousewheel!==i?"mousewheel":"DOMMouseScroll";"DOMMouseScroll"==a?t[e](o+"MozMousePixelScroll",Sn,!1):t[e](o+a,Sn,!1)}(),le.on("mousedown",Xn).on("mouseup",Vn)):(t.addEventListener?(t.removeEventListener("mousewheel",Sn,!1),t.removeEventListener("wheel",Sn,!1),t.removeEventListener("MozMousePixelScroll",Sn,!1)):t.detachEvent("onmousewheel",Sn),le.off("mousedown",Xn).off("mouseup",Vn))}function Ue(n, t){void 0!==t?(t=t.replace(/ /g,"").split(","),e.each(t,function(e, t){bt(n,t,"m")})):(bt(n,"all","m"),n?(Ge(!0),(ae||re)&&(V.autoScrolling&&_.off(Ce.touchmove).on(Ce.touchmove,vn),e(r).off(Ce.touchstart).on(Ce.touchstart,gn).off(Ce.touchmove).on(Ce.touchmove,hn))):(Ge(!1),(ae||re)&&(V.autoScrolling&&_.off(Ce.touchmove),e(r).off(Ce.touchstart).off(Ce.touchmove))))}function Qe(n, t){void 0!==t?(t=t.replace(/ /g,"").split(","),e.each(t,function(e, t){bt(n,t,"k")})):(bt(n,"all","k"),V.keyboardScrolling=n)}function Je(){var n=e(S).prev(m);n.length||!V.loopTop&&!V.continuousVertical||(n=e(m).last()),n.length&&yn(n,null,!0)}function Ke(){var n=e(S).next(m);n.length||!V.loopBottom&&!V.continuousVertical||(n=e(m).first()),n.length&&yn(n,null,!1)}function _e(e, n){je(0,"internal"),$e(e,n),je(Me.scrollingSpeed,"internal")}function $e(e, n){var t=st(e);void 0!==n?ct(e,n):t.length>0&&yn(t)}function en(e){wn("right",e)}function nn(e){wn("left",e)}function tn(n){if(!le.hasClass(c)){ce=!0,se=J.height(),e(m).each(function(){var n=e(this).find(E),t=e(this).find(I);V.verticalCentered&&e(this).find(y).css("height",rt(e(this))+"px"),e(this).css("height",ln(e(this))+"px"),t.length>1&&Un(n,n.find(L))}),V.scrollOverflow&&he.createScrollBarForAll();var t=e(S).index(m);t&&!yt("fadingEffect")&&_e(t+1),ce=!1,e.isFunction(V.afterResize)&&n&&V.afterResize.call(le),e.isFunction(V.afterReBuild)&&!n&&V.afterReBuild.call(le),le.trigger("afterRebuild")}}function on(n){var t=_.hasClass(l);n?t||(Ze(!1,"internal"),qe(!1,"internal"),e(M).hide(),_.addClass(l),e.isFunction(V.afterResponsive)&&V.afterResponsive.call(le,n),V.responsiveSlides&&$.responsiveSlides&&$.responsiveSlides.toSections(),le.trigger("afterResponsive",[n])):t&&(Ze(Me.autoScrolling,"internal"),qe(Me.autoScrolling,"internal"),e(M).show(),_.removeClass(l),e.isFunction(V.afterResponsive)&&V.afterResponsive.call(le,n),V.responsiveSlides&&$.responsiveSlides&&$.responsiveSlides.toSlides(),le.trigger("afterResponsive",[n]))}function an(e){var t="fp_"+e+"Extension";ke[e]=V[e+"Key"],$[e]=void 0!==n[t]?new n[t]:null,$[e]&&$[e].c(e)}function rn(n, t, o){var i=100*o,a=100/o;t.wrapAll('<div class="'+B+'" />'),t.parent().wrap('<div class="'+H+'" />'),n.find(D).css("width",i+"%"),o>1&&(V.controlArrows&&function(e){e.find(E).after('<div class="'+j+'"></div><div class="'+U+'"></div>'),"#fff"!=V.controlArrowColor&&(e.find(Q).css("border-color","transparent transparent transparent "+V.controlArrowColor),e.find(q).css("border-color","transparent "+V.controlArrowColor+" transparent transparent"));V.loopHorizontal||e.find(q).hide()}(n),V.slidesNavigation&&function(e, n){e.append('<div class="'+F+'"><ul></ul></div>');var t=e.find(W);t.addClass(V.slidesNavPosition);for(var o=0; o<n; o++)t.find("ul").append('<li><a href="#"><span></span></a></li>');t.css("margin-left","-"+t.width()/2+"px"),t.find("li").first().find("a").addClass(u)}(n,o)),t.each(function(n){e(this).css("width",a+"%"),V.verticalCentered&&at(e(this))});var r=n.find(L);r.length&&(0!==e(S).index(m)||0===e(S).index(m)&&0!==r.index())?(mt(r,"internal"),r.addClass(Y)):t.eq(0).addClass(u)}function ln(e){return V.offsetSections&&$.offsetSections?o.round($.offsetSections.getWindowHeight(e)):se}function sn(){var n,t=e(S);t.addClass(h),An(t),Mn(t),V.scrollOverflow&&V.scrollOverflowHandler.afterLoad(),(!(n=st(Pn().section))||n.length&&n.index()===oe.index())&&e.isFunction(V.afterLoad)&&V.afterLoad.call(t,t.data("anchor"),t.index(m)+1),e.isFunction(V.afterRender)&&V.afterRender.call(le),le.trigger("afterRender")}function cn(){Fe||(requestAnimationFrame(dn),Fe=!0)}function dn(){var n,i,a;if(le.trigger("onScroll"),(!V.autoScrolling||V.scrollBar||yt("dragAndMove"))&&!At()){var r=yt("dragAndMove")?o.abs($.dragAndMove.getCurrentScroll()):J.scrollTop(),l=(a=(i=r)>ze?"down":"up",ze=i,We=i,0),s=r+J.height()/2,c=(yt("dragAndMove")?$.dragAndMove.getDocumentHeight():_.height()-J.height())===r,d=t.querySelectorAll(m);if(c)l=d.length-1;else if(r)for(var f=0; f<d.length; ++f){d[f].offsetTop<=s&&(l=f)}else l=0;if(!(n=e(d).eq(l)).hasClass(u)){Re=!0;var v,h,p=e(S),g=p.index(m)+1,w=ot(n),b=n.data("anchor"),x=n.index(m)+1,y=n.find(L);y.length&&(h=y.data("anchor"),v=y.index()),fe&&(n.addClass(u).siblings().removeClass(u),Ct("parallax","afterLoad"),e.isFunction(V.onLeave)&&V.onLeave.call(p,g,x,w),e.isFunction(V.afterLoad)&&V.afterLoad.call(n,b,x),V.resetSliders&&$.resetSliders&&$.resetSliders.apply({localIsResizing:ce,leavingSection:g}),On(p),An(n),Mn(n),tt(b,x-1),V.anchors.length&&(ee=b),ft(v,h,b,x)),clearTimeout(Se),Se=setTimeout(function(){Re=!1},100)}V.fitToSection&&(clearTimeout(we),we=setTimeout(function(){V.fitToSection&&e(S).outerHeight()<=se&&fn()},V.fitToSectionDelay))}Fe=!1}function fn(){fe&&(ce=!0,yn(e(S)),ce=!1)}function un(n){if(ve.m[n]){var t="down"===n?Ke:Je;if($.scrollHorizontally&&(t=$.scrollHorizontally.getScrollSection(n,t)),V.scrollOverflow){var o=V.scrollOverflowHandler.scrollable(e(S)),i="down"===n?"bottom":"top";if(o.length>0){if(!V.scrollOverflowHandler.isScrolled(i,o))return!0;t()}else t()}else t()}}function vn(e){var n=e.originalEvent;V.autoScrolling&&pn(n)&&e.preventDefault()}function hn(n){var t=n.originalEvent,i=e(t.target).closest(m);if(pn(t)){V.autoScrolling&&n.preventDefault();var a=gt(t);He=a.y,Ee=a.x,i.find(E).length&&o.abs(Le-Ee)>o.abs(Ie-He)?!ie&&o.abs(Le-Ee)>J.outerWidth()/100*V.touchSensitivity&&(Le>Ee?ve.m.right&&en(i):ve.m.left&&nn(i)):V.autoScrolling&&fe&&o.abs(Ie-He)>J.height()/100*V.touchSensitivity&&(Ie>He?un("down"):He>Ie&&un("up"))}}function pn(e){return void 0===e.pointerType||"mouse"!=e.pointerType}function gn(e){var n=e.originalEvent;if(V.fitToSection&&G.stop(),pn(n)){var t=gt(n);Ie=t.y,Le=t.x}}function mn(e, n){for(var t=0,i=e.slice(o.max(e.length-n,1)),a=0; a<i.length; a++)t+=i[a];return o.ceil(t/n)}function Sn(t){var i=(new Date).getTime(),a=e(p).hasClass(T);if(V.autoScrolling&&!te&&!a){var r=(t=t||n.event).wheelDelta||-t.deltaY||-t.detail,l=o.max(-1,o.min(1,r)),s=void 0!==t.wheelDeltaX||void 0!==t.deltaX,c=o.abs(t.wheelDeltaX)<o.abs(t.wheelDelta)||o.abs(t.deltaX)<o.abs(t.deltaY)||!s;ue.length>149&&ue.shift(),ue.push(o.abs(r)),V.scrollBar&&(t.preventDefault?t.preventDefault():t.returnValue=!1);var d=i-Ye;if(Ye=i,d>200&&(ue=[]),fe&&!Tt())mn(ue,10)>=mn(ue,70)&&c&&un(l<0?"down":"up");return!1}V.fitToSection&&G.stop()}function wn(n, t){var o=(void 0===t?e(S):t).find(E);if(!(!o.length||Tt()||ie||o.find(I).length<2)){var i=o.find(L),a=null;if(!(a="left"===n?i.prev(I):i.next(I)).length){if(!V.loopHorizontal)return;a="left"===n?i.siblings(":last"):i.siblings(":first")}ie=!0,Un(o,a,n)}}function bn(){e(L).each(function(){mt(e(this),"internal")})}function xn(e){var n=e.position(),t=n.top,o=yt("dragAndMove")&&$.dragAndMove.isGrabbing?$.dragAndMove.isScrollingDown():n.top>We,i=t-se+e.outerHeight(),a=V.bigSectionsDestination;return e.outerHeight()>se?(o||a)&&"bottom"!==a||(t=i):(o||ce&&e.is(":last-child"))&&(t=i),V.offsetSections&&$.offsetSections&&(t=$.offsetSections.getSectionPosition(o,t,e)),We=t,t}function yn(n, t, i){if(void 0!==n&&n.length){var a,l,s={element:n,callback:t,isMovementUp:i,dtop:xn(n),yMovement:ot(n),anchorLink:n.data("anchor"),sectionIndex:n.index(m),activeSlide:n.find(L),activeSection:e(S),leavingSection:e(S).index(m)+1,localIsResizing:ce};if(!(s.activeSection.is(n)&&!ce||V.scrollBar&&J.scrollTop()===s.dtop&&!n.hasClass(C))){if(s.activeSlide.length&&(a=s.activeSlide.data("anchor"),l=s.activeSlide.index()),e.isFunction(V.onLeave)&&!s.localIsResizing){var c=s.yMovement;if(void 0!==i&&(c=i?"up":"down"),!1===V.onLeave.call(s.activeSection,s.leavingSection,s.sectionIndex+1,c))return}Ct("parallax","apply",s),V.autoScrolling&&V.continuousVertical&&void 0!==s.isMovementUp&&(!s.isMovementUp&&"up"==s.yMovement||s.isMovementUp&&"down"==s.yMovement)&&(s=function(n){n.isMovementUp?n.activeSection.before(n.activeSection.nextAll(m)):n.activeSection.after(n.activeSection.prevAll(m).get().reverse());return St(e(S).position().top),bn(),n.wrapAroundElements=n.activeSection,n.dtop=n.element.position().top,n.yMovement=ot(n.element),n.leavingSection=n.activeSection.index(m)+1,n.sectionIndex=n.element.index(m),e(r).trigger("onContinuousVertical",[n]),n}(s)),yt("scrollOverflowReset")&&$.scrollOverflowReset.setPrevious(s.activeSection),s.localIsResizing||On(s.activeSection),V.scrollOverflow&&V.scrollOverflowHandler.beforeLeave(),n.addClass(u).siblings().removeClass(u),An(n),V.scrollOverflow&&V.scrollOverflowHandler.onLeave(),fe=!1,ft(l,a,s.anchorLink,s.sectionIndex),function(n){if(V.css3&&V.autoScrolling&&!V.scrollBar){var t="translate3d(0px, -"+o.round(n.dtop)+"px, 0px)";lt(t,!0),V.scrollingSpeed?(clearTimeout(ge),ge=setTimeout(function(){Cn(n)},V.scrollingSpeed)):Cn(n)}else{var i=function(e){var n={};V.autoScrolling&&!V.scrollBar?(n.options={top:-e.dtop},n.element=r):(n.options={scrollTop:e.dtop},n.element="html, body");return n}(n);e(i.element).animate(i.options,V.scrollingSpeed,V.easing).promise().done(function(){V.scrollBar?setTimeout(function(){Cn(n)},30):Cn(n)})}}(s),ee=s.anchorLink,tt(s.anchorLink,function(n){if(n.wrapAroundElements&&n.wrapAroundElements.length)return n.isMovementUp?e(m).length-1:0;return n.sectionIndex}(s))}}}function Cn(n){var t;(t=n).wrapAroundElements&&t.wrapAroundElements.length&&(t.isMovementUp?e(w).before(t.wrapAroundElements):e(b).after(t.wrapAroundElements),St(e(S).position().top),bn(),t.sectionIndex=t.element.index(m),t.leavingSection=t.activeSection.index(m)+1),e.isFunction(V.afterLoad)&&!n.localIsResizing&&V.afterLoad.call(n.element,n.anchorLink,n.sectionIndex+1),V.scrollOverflow&&V.scrollOverflowHandler.afterLoad(),Ct("parallax","afterLoad"),yt("scrollOverflowReset")&&$.scrollOverflowReset.reset(),V.resetSliders&&$.resetSliders&&$.resetSliders.apply(n),n.localIsResizing||Mn(n.element),n.element.addClass(h).siblings().removeClass(h),fe=!0,e.isFunction(n.callback)&&n.callback.call(this)}function Tn(e, n){e.attr(n,e.data(n)).removeAttr("data-"+n)}function An(n){var t;V.lazyLoading&&Rn(n).find("img[data-src], img[data-srcset], source[data-src], source[data-srcset], video[data-src], audio[data-src], iframe[data-src]").each(function(){if(t=e(this),e.each(["src","srcset"],function(e, n){var o=t.attr("data-"+n);void 0!==o&&o&&Tn(t,n)}),t.is("source")){var n=t.closest("video").length?"video":"audio";t.closest(n).get(0).load()}})}function Mn(n){var t=Rn(n);t.find("video, audio").each(function(){var n=e(this).get(0);n.hasAttribute("data-autoplay")&&"function"==typeof n.play&&n.play()}),t.find('iframe[src*="youtube.com/embed/"]').each(function(){var n=e(this).get(0);n.hasAttribute("data-autoplay")&&kn(n),n.onload=function(){n.hasAttribute("data-autoplay")&&kn(n)}})}function kn(e){e.contentWindow.postMessage('{"event":"command","func":"playVideo","args":""}',"*")}function On(n){var t=Rn(n);t.find("video, audio").each(function(){var n=e(this).get(0);n.hasAttribute("data-keepplaying")||"function"!=typeof n.pause||n.pause()}),t.find('iframe[src*="youtube.com/embed/"]').each(function(){var n=e(this).get(0);/youtube\.com\/embed\//.test(e(this).attr("src"))&&!n.hasAttribute("data-keepplaying")&&e(this).get(0).contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}',"*")})}function Rn(n){var t=n.find(L);return t.length&&(n=e(t)),n}function zn(e){var n="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";function t(e){var t,o,i,a,r,l,s="",c=0;for(e=e.replace(/[^A-Za-z0-9+/=]/g,""); c<e.length;)t=n.indexOf(e.charAt(c++))<<2|(a=n.indexOf(e.charAt(c++)))>>4,o=(15&a)<<4|(r=n.indexOf(e.charAt(c++)))>>2,i=(3&r)<<6|(l=n.indexOf(e.charAt(c++))),s+=String.fromCharCode(t),64!=r&&(s+=String.fromCharCode(o)),64!=l&&(s+=String.fromCharCode(i));return s=function(e){var n,t="",o=0,i=0,a=0;for(; o<e.length;)(i=e.charCodeAt(o))<128?(t+=String.fromCharCode(i),o++):i>191&&i<224?(a=e.charCodeAt(o+1),t+=String.fromCharCode((31&i)<<6|63&a),o+=2):(a=e.charCodeAt(o+1),n=e.charCodeAt(o+2),t+=String.fromCharCode((15&i)<<12|(63&a)<<6|63&n),o+=3);return t}(s)}function o(e){return e.slice(3).slice(0,-3)}return function(e){var n=e.split("_");if(n.length>1){var i=n[1];return e.replace(o(n[1]),"").split("_")[0]+"_"+t(i.slice(3).slice(0,-3))}return o(e)}(t(e))}function In(e){var n=function(){if(t.domain.length){for(var e=t.domain.replace(/^(www\.)/,"").split("."); e.length>2;)e.shift();return e.join(".").replace(/(^\.*)|(\.*$)/g,"")}return""}(),o=["MTM0bG9jYWxob3N0MjM0","MTM0MC4xMjM0","MTM0anNoZWxsLm5ldDIzNA==","UDdDQU5ZNlNN"],i=zn(o[0]),a=zn(o[1]),r=zn(o[2]),l=zn(o[3]),s=[i,a,r].indexOf(n)<0&&0!==n.length,c=void 0!==ke[e]&&ke[e].length;if(!c&&s)return!1;var d=c?zn(ke[e]):"",f=(d=d.split("_")).length>1&&d[1].indexOf(e,d[1].length-e.length)>-1;return!(d[0].indexOf(n,d[0].length-n.length)<0&&s&&l!=d[0])&&f||!s}function Ln(n){Be=zn("MTIzPGRpdj48YSBocmVmPSJodHRwOi8vYWx2YXJvdHJpZ28uY29tL2Z1bGxQYWdlL2V4dGVuc2lvbnMvIiBzdHlsZT0iY29sb3I6ICNmZmYgIWltcG9ydGFudDsgdGV4dC1kZWNvcmF0aW9uOm5vbmUgIWltcG9ydGFudDsiPlVubGljZW5zZWQgZnVsbFBhZ2UuanMgRXh0ZW5zaW9uPC9hPjwvZGl2PjEyMw=="),De=e("<div/>").html(Be).contents(),yt(n)&&$[n]&&(In(n)||(Hn(),setInterval(Hn,2e3)))}function Hn(){Te||(o.random()<.5?_.prepend(De):_.append(De),Te=!0,De.bind("destroyed",function(){clearTimeout(Pe),Pe=setTimeout(En,900)})),e(De).attr("style",zn("MTIzei1pbmRleDo5OTk5OTk5O3Bvc2l0aW9uOmZpeGVkO3RvcDoyMHB4O2JvdHRvbTphdXRvO2xlZnQ6MjBweDtyaWdodDphdXRvO2JhY2tncm91bmQ6cmVkO3BhZGRpbmc6N3B4IDE1cHg7Zm9udC1zaXplOjE0cHg7Zm9udC1mYW1pbHk6YXJpYWw7Y29sb3I6I2ZmZjtkaXNwbGF5OmlubGluZS1ibG9jazt0cmFuc2Zvcm06dHJhbnNsYXRlM2QoMCwwLDApO29wYWNpdHk6MTtoZWlnaHQ6YXV0bzt3aWR0aDphdXRvO3pvb206MTttYXJnaW46YXV0bztib3JkZXI6bm9uZTt2aXNpYmlsaXR5OnZpc2libGU7Y2xpcC1wYXRoOm5vbmU7MTIz").replace(/;/g,zn("MTIzICFpbXBvcnRhbnQ7MzQ1")))}function En(){Te=!1}function Bn(){var e=Pn(),n=e.section,t=e.slide;n&&(V.animateAnchor?ct(n,t):_e(n,t))}function Dn(){if(!Re&&!V.lockAnchors){var e=Pn(),n=e.section,t=e.slide,o=void 0===ee,i=void 0===ee&&void 0===t&&!ie;n&&n.length&&(n&&n!==ee&&!o||i||!ie&&ne!=t)&&ct(n,t)}}function Pn(){var e,t,o=n.location.hash;if(o.length){var i=o.replace("#","").split("/"),a=o.indexOf("#/")>-1;e=a?"/"+i[1]:decodeURIComponent(i[0]);var r=a?i[2]:i[1];r&&r.length&&(t=decodeURIComponent(r))}return{section:e,slide:t}}function Yn(n){clearTimeout(be);var t=e(":focus"),o=n.which;if(9===o)!function(n){var t=n.shiftKey,o=e(":focus"),i=e(S),a=i.find(L),r=(a.length?a:i).find(Ae).not('[tabindex="-1"]');function l(e){return e.preventDefault(),r.first().focus()}o.length?o.closest(S,L).length||(o=l(n)):l(n);(!t&&o.is(r.last())||t&&o.is(r.first()))&&n.preventDefault()}(n);else if(!t.is("textarea")&&!t.is("input")&&!t.is("select")&&"true"!==t.attr("contentEditable")&&""!==t.attr("contentEditable")&&V.keyboardScrolling&&V.autoScrolling){e.inArray(o,[40,38,32,33,34])>-1&&n.preventDefault(),te=n.ctrlKey,be=setTimeout(function(){!function(n){var t=n.shiftKey;if(!fe&&[37,39].indexOf(n.which)<0)return;switch(n.which){case 38:case 33:ve.k.up&&Je();break;case 32:if(t&&ve.k.up){Je();break}case 40:case 34:ve.k.down&&Ke();break;case 36:ve.k.up&&$e(1);break;case 35:ve.k.down&&$e(e(m).length);break;case 37:ve.k.left&&nn();break;case 39:ve.k.right&&en();break;default:;}}(n)},150)}}function Fn(){e(this).prev().trigger("click")}function Wn(e){de&&(te=e.ctrlKey)}function Xn(e){2==e.which&&(Xe=e.pageY,le.on("mousemove",Gn))}function Vn(e){2==e.which&&le.off("mousemove")}function Zn(){var n=e(this).closest(m);e(this).hasClass(N)?ve.m.left&&nn(n):ve.m.right&&en(n)}function Nn(){de=!1,te=!1}function jn(n){n.preventDefault();var t=e(this).parent().index();yn(e(m).eq(t))}function qn(n){n.preventDefault();var t=e(this).closest(m).find(E);Un(t,t.find(I).eq(e(this).closest("li").index()))}function Gn(e){fe&&(e.pageY<Xe&&ve.m.up?Je():e.pageY>Xe&&ve.m.down&&Ke()),Xe=e.pageY}function Un(n, t, o){var i=n.closest(m),a={slides:n,destiny:t,direction:o,destinyPos:t.position(),slideIndex:t.index(),section:i,sectionIndex:i.index(m),anchorLink:i.data("anchor"),slidesNav:i.find(W),slideAnchor:vt(t),prevSlide:i.find(L),prevSlideIndex:i.find(L).index(),localIsResizing:ce};a.xMovement=it(a.prevSlideIndex,a.slideIndex),a.localIsResizing||(fe=!1),Ct("parallax","applyHorizontal",a),V.onSlideLeave&&!a.localIsResizing&&"none"!==a.xMovement&&e.isFunction(V.onSlideLeave)&&!1===V.onSlideLeave.call(a.prevSlide,a.anchorLink,a.sectionIndex+1,a.prevSlideIndex,a.direction,a.slideIndex)?ie=!1:(t.addClass(u).siblings().removeClass(u),a.localIsResizing||(On(a.prevSlide),An(t)),Qn(a),i.hasClass(u)&&!a.localIsResizing&&ft(a.slideIndex,a.slideAnchor,a.anchorLink,a.sectionIndex),$.continuousHorizontal&&$.continuousHorizontal.apply(a),At()?Jn(a):Kn(n,a,!0),V.interlockedSlides&&$.interlockedSlides&&(yt("continuousHorizontal")&&void 0!==o&&o!==a.xMovement||$.interlockedSlides.apply(a)))}function Qn(e){!V.loopHorizontal&&V.controlArrows&&(e.section.find(q).toggle(0!==e.slideIndex),e.section.find(Q).toggle(!e.destiny.is(":last-child")))}function Jn(n){var t,o;$.continuousHorizontal&&$.continuousHorizontal.afterSlideLoads(n),t=n.slidesNav,o=n.slideIndex,t.find(v).removeClass(u),t.find("li").eq(o).find("a").addClass(u),n.localIsResizing||(Ct("parallax","afterSlideLoads"),e.isFunction(V.afterSlideLoad)&&V.afterSlideLoad.call(n.destiny,n.anchorLink,n.sectionIndex+1,n.slideAnchor,n.slideIndex),fe=!0,Mn(n.destiny)),ie=!1,yt("interlockedSlides")&&$.interlockedSlides.apply(n)}function Kn(e, n, t){var i=n.destinyPos;if(V.css3){var a="translate3d(-"+o.round(i.left)+"px, 0px, 0px)";et(e.find(D)).css(wt(a)),me=setTimeout(function(){t&&Jn(n)},V.scrollingSpeed,V.easing)}else e.animate({scrollLeft:o.round(i.left)},V.scrollingSpeed,V.easing,function(){t&&Jn(n)})}function _n(){if(le.trigger("onResize"),$n(),ae){var n=e(t.activeElement);if(!n.is("textarea")&&!n.is("input")&&!n.is("select")){var i=J.height();o.abs(i-Ve)>20*o.max(Ve,i)/100&&(tn(!0),Ve=i)}}else clearTimeout(pe),pe=setTimeout(function(){tn(!0)},350)}function $n(){var e=V.responsive||V.responsiveWidth,n=V.responsiveHeight,t=e&&J.outerWidth()<e,o=n&&J.height()<n;e&&n?on(t||o):e?on(t):n&&on(o)}function et(e){var n="all "+V.scrollingSpeed+"ms "+V.easingcss3;return e.removeClass(s),e.css({"-webkit-transition":n,transition:n})}function nt(e){return e.addClass(s)}function tt(n, t){var o,i,a;o=n,V.menu&&(e(V.menu).find(v).removeClass(u),e(V.menu).find('[data-menuanchor="'+o+'"]').addClass(u)),i=n,a=t,V.navigation&&(e(M).find(v).removeClass(u),i?e(M).find('a[href="#'+i+'"]').addClass(u):e(M).find("li").eq(a).find("a").addClass(u))}function ot(n){var t=e(S).index(m),o=n.index(m);return t==o?"none":t>o?"up":"down"}function it(e, n){return e==n?"none":e>n?"left":"right"}function at(n){if(!n.hasClass(P)){var t=e('<div class="'+x+'" />').height(rt(n));n.addClass(P).wrapInner(t)}}function rt(e){var n=ln(e);if(V.paddingTop||V.paddingBottom){var t=e;t.hasClass(g)||(t=e.closest(m)),n-=parseInt(t.css("padding-top"))+parseInt(t.css("padding-bottom"))}return n}function lt(e, n){n?et(le):nt(le),clearTimeout(xe),le.css(wt(e)),xe=setTimeout(function(){le.removeClass(s)},10)}function st(n){var t=le.find(m+'[data-anchor="'+n+'"]');if(!t.length){var o=void 0!==n?n-1:0;t=e(m).eq(o)}return t}function ct(e, n){var t=st(e);if(t.length){var o,i,a,r=(o=n,(a=(i=t).find(I+'[data-anchor="'+o+'"]')).length||(o=void 0!==o?o:0,a=i.find(I).eq(o)),a);e===ee||t.hasClass(u)?dt(r):yn(t,function(){dt(r)})}}function dt(e){e.length&&Un(e.closest(E),e)}function ft(e, n, t, o){var i="";V.anchors.length&&!V.lockAnchors&&(e?(void 0!==t&&(i=t),void 0===n&&(n=e),ne=n,ut(i+"/"+n)):void 0!==e?(ne=n,ut(t)):ut(t)),ht()}function ut(e){if(V.recordHistory)location.hash=e;else if(ae||re)n.history.replaceState(i,i,"#"+e);else{var t=n.location.href.split("#")[0];n.location.replace(t+"#"+e)}}function vt(e){var n=e.data("anchor"),t=e.index();return void 0===n&&(n=t),n}function ht(){var n=e(S),t=n.find(L),o=vt(n),i=vt(t),a=String(o);t.length&&(a=a+"-"+i),a=a.replace("/","-").replace("#","");var r=new RegExp("\\b\\s?"+f+"-[^\\s]+\\b","g");_[0].className=_[0].className.replace(r,""),_.addClass(f+"-"+a)}function pt(){return n.PointerEvent?{down:"pointerdown",move:"pointermove"}:{down:"MSPointerDown",move:"MSPointerMove"}}function gt(e){var n=[];return n.y=void 0!==e.pageY&&(e.pageY||e.pageX)?e.pageY:e.touches[0].pageY,n.x=void 0!==e.pageX&&(e.pageY||e.pageX)?e.pageX:e.touches[0].pageX,re&&pn(e)&&V.scrollBar&&void 0!==e.touches&&(n.y=e.touches[0].pageY,n.x=e.touches[0].pageX),n}function mt(e, n){je(0,"internal"),void 0!==n&&(ce=!0),Un(e.closest(E),e),void 0!==n&&(ce=!1),je(Me.scrollingSpeed,"internal")}function St(e){var n=o.round(e);V.css3&&V.autoScrolling&&!V.scrollBar?lt("translate3d(0px, -"+n+"px, 0px)",!1):V.autoScrolling&&!V.scrollBar?le.css("top",-n):G.scrollTop(n)}function wt(e){return{"-webkit-transform":e,"-moz-transform":e,"-ms-transform":e,transform:e}}function bt(n, t, o){"all"!==t?ve[o][t]=n:e.each(Object.keys(ve[o]),function(e, t){ve[o][t]=n})}function xt(e){return e.css({"-webkit-transition":"none",transition:"none"})}function yt(e){return null!==V[e]&&"object"==typeof V[e]?V[e].enabled&&$[e]:V[e]&&$[e]}function Ct(e, n, t){if(yt(e))return $[e][n](t)}function Tt(){return yt("dragAndMove")&&$.dragAndMove.isAnimating}function At(){return yt("dragAndMove")&&$.dragAndMove.isGrabbing}function Mt(e, n, t){V[e]=n,"internal"!==t&&(Me[e]=n)}function kt(){e("html").hasClass(d)?Ot("error","Fullpage.js can only be initialized once and you are doing it multiple times!"):(V.continuousVertical&&(V.loopTop||V.loopBottom)&&(V.continuousVertical=!1,Ot("warn","Option `loopTop/loopBottom` is mutually exclusive with `continuousVertical`; `continuousVertical` disabled")),V.scrollBar&&V.scrollOverflow&&Ot("warn","Option `scrollBar` is mutually exclusive with `scrollOverflow`. Sections with scrollOverflow might not work well in Firefox"),!V.continuousVertical||!V.scrollBar&&V.autoScrolling||(V.continuousVertical=!1,Ot("warn","Scroll bars (`scrollBar:true` or `autoScrolling:false`) are mutually exclusive with `continuousVertical`; `continuousVertical` disabled")),V.scrollOverflow&&!V.scrollOverflowHandler&&(V.scrollOverflow=!1,Ot("error","The option `scrollOverflow:true` requires the file `scrolloverflow.min.js`. Please include it before fullPage.js.")),e.each(V.anchors,function(n, t){var o=K.find("[name]").filter(function(){return e(this).attr("name")&&e(this).attr("name").toLowerCase()==t.toLowerCase()}),i=K.find("[id]").filter(function(){return e(this).attr("id")&&e(this).attr("id").toLowerCase()==t.toLowerCase()});(i.length||o.length)&&(Ot("error","data-anchor tags can not have the same value as any `id` element on the site (or `name` element for IE)."),i.length&&Ot("error",'"'+t+'" is is being used by another element `id` property'),o.length&&Ot("error",'"'+t+'" is is being used by another element `name` property'))}))}function Ot(e, n){console&&console[e]&&console[e]("fullPage: "+n)}}});
